import Swal from 'sweetalert2';
import { SimpleDataTable } from 'src/app/shared/data/tables_data/data_table';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { EspecialidadesService } from 'src/app/services/empresa/especialidades.service';
import { PaisesService } from 'src/app/services/empresa/paises.service';
import { PacientesService } from 'src/app/services/personas/pacientes.service';
import { DoctoresService } from 'src/app/services/personas/doctores.service';
import { ServiciosService } from 'src/app/services/inventario/servicios.service';
import { DescuentosService } from 'src/app/services/transacciones/descuentos.service';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { SolicitudesPreciosAdministracionService } from 'src/app/services/empresa/solicitudes-precios-administracion.service';

type DocumentoFacturaLink = {
  action: 'nodeCustomerTicket' | 'nodeInternalReceipt' | 'nodeLabSampleTicket';
  icon: string;
  idOrden: string;
  label: string;
  numeroFactura: string;
  tipoFactura: string;
};


type SolicitudPrecioResultado = {
  id?: string | number;
  aprobado?: boolean;
  accion?: 'aprobar' | 'rechazar';
  codigo?: string;
  doctor?: string;
  estado?: string;
  mensaje?: string;
  numeroSolicitud?: string;
  precioNormal?: string;
  precioSolicitado?: string;
  servicio?: string;
};


@Component({
  selector: 'app-crear-descuento',
  templateUrl: './crear-descuento.component.html',
  styleUrls: ['./crear-descuento.component.scss'],
  standalone: false
})
export class CrearDescuentoComponent implements OnInit {
 
  @ViewChild('modalMultiplesPagos') modalMultiplesPagos;
  @ViewChild('modalOrderPendingPaciente') modalOrderPendingPaciente;
  @ViewChild('modalCompaniaTarjeta') modalCompaniaTarjeta!: ElementRef<NgbModal>;
  @ViewChild('mdlDocumentosFactura') mdlDocumentosFacturaRef: any;

  parseJson(str: string): any {
    return JSON.parse(str);
  }
 
  @ViewChild(DataTableDirective, {static: false})


  
  dtElement!: DataTableDirective;
  isDtInitialized:boolean = false
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  public contenedorDoctor :boolean = false;
  public mobileTab: 'paciente' | 'doctor' = 'paciente';
  public showAllSpecialties = false;
  public selected: string = "";
  public selectedDoctor: string = "";
  public pacienteslist!: any[];
  public doctoreslist!: any[];
  public especialidadesOrdenlist!: any[];
  public serviciolist!: any[];
  public timeout:any;
  public nombre: string = "";
  public identificacion: string = "";
  public telefono: string = "";
  public telefonoClon: string = "";
  public direccion: string = "";
  public fechaNacimiento: string = "";
  public email: string = "";
  public mTelefonoDoctor: boolean = false;
  public checkIdentificacionSI: boolean = false;
  public checkIdentificacionNO: boolean = false;
  public randomCedula: string = "";
  public checkTelefonoSI: boolean = false;
  public checkTelefonoNO: boolean = false;
  public checkFacturarOtrasPersonasSI: boolean = false;
  public checkConsumidorFinalNO: boolean = false;
  public identificacionAdicional:string = "";
  public nombreAdicional: string = "";
  public direccionAdicional: string = "GUAYAQUIL";
  public spinnerBooleanBuscarData : boolean = false;
  public identificacionPaciente: string = "";
  public nombrePaciente: string = "";
  public fechaNacimientoPaciente: string = "";
  public direccionPaciente: string = "";
  public sexoPaciente: string = "";
  public paisesList!: any[];
  public pais: string = "3|593|(000) 00 0000 000";
  public inputMaskPais : string = "";
  public nuevoTelefonoCliente: string = "";
  public nuevaIdentificacionPaciente: string = "05";
  public nuevaIdentificacionPacienteOP: string = "05";
  public nuevoEmailPaciente: string = "cmsalud.manager@gmail.com";
  public nuevaEdadPaciente: string = "";
  public spinnerBooleanBuscarDataAdicional:boolean = false;
  public idPaciente: string = "";
  public codigoDoctor: string = "";
  public observacionesPaciente: string = "";

  public nombreDoctor: string = "";
  public cedulaDoctor: string = "";
  public telefonoDoctor: string = "";
  public direccionDoctor: string = "";
  public emailDoctor: string = "";
  public editarTelefonoDoctor: boolean = false;
  public telefonoDoctorClon: string = "";
  public especialidadesList: any[] = [];

  public companiasList:any[] = [];
  public _ordersPendingPatient:any[] = [];

  //AGREGAR DOCTOR
  public nuevoNombreDoctor: string = "";
  public nuevaFechaNDoctor: string = "";
  public nuevoTelefonoDoctor: string = "";
  public nuevoEmailDoctor: string = "cmsalud.manager@gmail.com";
  public nuevaDireccionDoctor: string = "GUAYAQUIL";
  public nuevoSexoDoctor: string = "";
  public nuevaEdadDoctor: string = "";
  public bancoDoctor: string = "ESTUDIANTE";
  public cuentaDoctor: string = "ESTUDIANTE";
  public talonarioDocotor: string = "";
  public nuevaIdentificacionDoctor: string = "05";
  public identificacionDoctor : string ="";
  public especialidaDoctor : string = "";
  public contadorG: number = 0;

  //SOLICITAR ORDENES FISICA
  public checkSolicitarOrdn: boolean = false;
  public nuevaDescripcionSolicitdOF : string = "";
  public asesorDoctor: string = "";

  //SOLICITUD
  public nuevaFechaCapacitar: string = "";
  public nuevoComentarioCapacitar: string = "";
  public checkTomografia: boolean = false;
  public dosD: boolean = false;
  public app: boolean = false;
  public concatSolicitud: string = "";
  public contador:number = 0;
  public mostrarModal: boolean = false;
  subscription: any;
  public totalPaginas:number = 0;
  public totalSeleccionado:number = 0;
  public pageNumber: number;
  public buscarOrden: string = "";
  public  spinnerBoolean:boolean = false;
  public size: number;
  public totalElements: number;
  public servicios: any = [];
  public tipo: string = "";
  public buscarServicio: string = "";
  public talonarioDocotorGet: string = "";
  public valorFinalModal: string = "";
  public servicioEscodigo: string = "";
  public checkMConductometria: boolean = false;
  public checkMIzquierda: boolean = false;
  public checkMDerecha: boolean = false;
  public checkMAbierto: boolean = false;
  public checkMCerrado: boolean = false;
  public checkMSuperior: boolean = false;
  public checkMInferior: boolean = false;

  public checkConductometria: boolean = false;
  public checkIzquierda: boolean = false;
  public checkDerecha: boolean = false;
  public checkAbierto: boolean = false;
  public checkCerrado: boolean = false;
  public checkSuperior: boolean = false;
  public checkInferior: boolean = false;
  

  public cadenaPiezas: string = "";
  public cadenaConduct: string = "";
  public cadenaAB: string = "";
  public cadenaIZ: string = "";
  public cadenaSI: string = "";

  //DETALLE ORDEN
  public servicioDetalle: string = "";
  public nombreDetalle: string = ""; 
  public idDetalle: string = "";
  public precio1Detalle: string = ""; 
  public precio2Detalle: string = ""; 
  public precio3Detalle: string = ""; 
  public precio4Detalle: string = ""; 
  public precioDerivado: string = "";  
  detalleOrden: any[] = [];
  _listadoAnalisis: any[] = [];
  analisisSeleccionados: any[] = [];
  public esAnalisiCefa:string = "No";
  itemDetalle: any= {};

  //DEMISIONES
  public dime1:boolean = false;
  public dime2:boolean = false;
  public dime3:boolean = false;
  public dime4:boolean = false;
  public dime5:boolean = false;
  public dime6:boolean = false;
  //PERFILES
  public listaPerfiles!: any[];
  public listaSubServicios!: any[];

  public impuesto : string = "";
  public incluidoIva: string = "";

  //
  public subtotalImpuesto : string = "0.00";
  public subtotalSinImpuesto: string = "0.00";
  public subtotal: string = "0.00";
  public iva: string = "0.00";
  public total: string = "0.00";

  public productoSeleccionadoCP: string = "";
  public idProductoSeleccionadoCP: string = "";
  public codigoProductoSeleccionadoCP : string = "";

  public preciosCambioList!: any[];

  public cbxPrecioSugerido: boolean = false;
  public cbxCuponDescuento: boolean = false;
  public txtPreciosDisponibles: string = "";
  public contenedorValidarPrecio: boolean = false;
  
  private _usuario!: Usuario;
  public nombreUsuario!:string;
  public idUsuario!:string;
  public idSucursal!:string
  public nombreSucursal!:string
  public secuencial!:string;


  //VARIABLES PARA SOLICITAR 
  public precioNormalSolicitad: string= "";
  public servicioSolicitud: string = "";
  public precioSolicitado: string= "";
  public nombreServicioSolicitado: string = "";
  public tipoSolicitud:string="";
  public codigoValidacion:string = "";
  public codigoFacturadorValidacion:string = "";
  public solicitudPrecioActualId:string = "";
  public solicitudPrecioResultado: SolicitudPrecioResultado | null = null;
  public codigosAprobadosHoy: any[] = [];
  public cargandoCodigosAprobados = false;
  public txtPrecioSugerido:string = "";
  public txtCuponDescuento:string = "";
  public index:number = 0;
  public precioSugerido:string = "PRECIO SUGERIDO";

  //GUARDAR TRANSACCION
  public dineroEntregar: string = "";
  public dineroEnt: number = 0;

  public nuevoTelefonoEnCardP:string = "";
  public nuevoTelefonoEnCardD:string = "";

  public cargando:string = "Generando orden...";
  public dineroRecibido:string = "";
  public guardarOrden:boolean = false;
  public errorTransaccion:boolean = false;
  public docLinks: DocumentoFacturaLink[] = [];
  public docNumFactura: string = '';
  public errorCapturado:string = "";
  public guardarPac:boolean = false;
  public contadorOrden:any = 0;

  public txtPruebaInformacion: string = "";
  public txtMuestrarInformacion: string = "";
  public txtContenedor: string = "";
  public txtCondicion: string = "";
  public txtEntregaResultados: string = "";
  public reserved: Number = 0

  public metodoPagoV:string="";

  public companiaBancaria:string='';
  public esTarjeta:boolean = false;

  //MULTIPLES FORMAS DE PAGO
  modalMetodoPago: string = "";
  modalImportePago: string = "";
  mostrarInfoTarjeta: boolean = false;
  modalTipoTarjeta: string = "";
  arrayPagos: any = [];
  valorCancelado: string = "0.00";
  valorPendiente: string = "0.00";
  spinnerGuardarMP: boolean = false;
  disabledGuardarMP: boolean = false;
  impuestoTarjeta: number = 0;
  public infoAdicional = {};
  tipoMensaje:string = "";
  allSelected: boolean = true; 
  emergency: boolean = false;
  listaSubServiciosCorporal!: any[];
  subservaciosSeleccionadosCorporal: any[] = [];

  @ViewChild(DatatableComponent, { static: false }) table!: DatatableComponent;
  dataTable = SimpleDataTable;
  private solicitudPrecioSubscription?: Subscription;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private pacientesService: PacientesService,
    private doctoresService: DoctoresService,
    private modalService: NgbModal,
    private paisesService: PaisesService,
    private especialidadesService: EspecialidadesService,
    private serviciosService: ServiciosService,
    private toastr: ToastrService,
    private authService: AuthService,
    private ordenesService: OrdenesService,
    private solicitudesPreciosAdministracionService: SolicitudesPreciosAdministracionService
  ) {

    this.pageNumber = 0;
    this.size = 5;
    this.totalElements = 0;
    this._usuario = authService.loginUsuario;
 
   }

  public metodosPagos: String = "MÉTODOS DE PAGO";


  ngOnInit(): void {

    this.mostrarPaises();
    this.especialidadesDoctor();
    this.mostrarEspecialidades();
    this.obtenerPerfiles();
    this.obtenerServiciosConSubServicios();
    this.mostrarCompaniasTarjeta();
   
    this.setPage({ offset: 0 });
    this.metodosPagos = 'EFECTIVO';
    this.metodoPagoV = 'EFECTIVO';
    this.contenedorDoctor = true;
    this.esTarjeta = false;
    this.nombreUsuario = this._usuario.nombre!;
    this.idUsuario = this._usuario.idUsuario!;
    this.idSucursal = this._usuario.sucursal!;
    this.nombreSucursal = this._usuario.nombreSucursal!;
    this.secuencial = this._usuario.secuencial!;
    this.escucharRespuestaSolicitudPrecio();
  
  

   

  }


  ngAfterViewInit(): void {
  
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.solicitudPrecioSubscription?.unsubscribe();
    this.dtTrigger.unsubscribe();
  }



  private escucharRespuestaSolicitudPrecio(): void {
    this.solicitudPrecioSubscription =
      this.solicitudesPreciosAdministracionService.solicitudProcesada$.subscribe((payload: SolicitudPrecioResultado) => {
        const idEvento = String(payload?.id || '');
        if (!idEvento || idEvento !== String(this.solicitudPrecioActualId || '')) {
          return;
        }

        this.solicitudPrecioResultado = payload;
        if (payload?.aprobado && payload?.codigo) {
          this.codigoFacturadorValidacion = String(payload.codigo);
          this.actualizarCodigosAprobadosHoy(false);
        }
      });
  }

  actualizarCodigosAprobadosHoy(mostrarMensaje = true): void {
    const userId = String(this.idUsuario || '').trim();
    const branchId = String(this.idSucursal || '').trim();
    if (!userId || !branchId) {
      return;
    }

    this.cargandoCodigosAprobados = true;
    this.solicitudesPreciosAdministracionService
      .listarCodigosAprobadosHoy(userId, branchId, 5)
      .subscribe({
        next: (resp: any) => {
          this.codigosAprobadosHoy = Array.isArray(resp?.rows) ? resp.rows : [];
          this.cargandoCodigosAprobados = false;
          if (mostrarMensaje) {
            this.toastr.info('Lista de códigos actualizada.', 'Códigos aprobados', {
              timeOut: 2000,
              closeButton: true,
              progressBar: true
            });
          }
        },
        error: () => {
          this.cargandoCodigosAprobados = false;
          if (mostrarMensaje) {
            this.toastr.error('No se pudo actualizar la lista de códigos aprobados.', 'Atención', {
              timeOut: 5000,
              closeButton: true,
              progressBar: true
            });
          }
        }
      });
  }

  usarCodigoAprobado(codigo: string): void {
    const codigoLimpio = String(codigo || '').trim();
    if (!codigoLimpio) {
      return;
    }

    this.codigoFacturadorValidacion = codigoLimpio;
    navigator.clipboard?.writeText(codigoLimpio).catch(() => {});
    this.toastr.success('Código colocado para validar.', 'Código aprobado', {
      timeOut: 2500,
      closeButton: true,
      progressBar: true
    });
  }


  mostrarCompaniasTarjeta(){
    this.ordenesService.companiasTarjetaDebitoCredito().subscribe((resp)=>{
      if(resp.length > 0){
        resp.forEach((tarjeta) => {
          let objTarjeta = {
            COD_TARJE: tarjeta.COD_TARJE,
            NOM_TARJE: tarjeta.NOM_TARJE
          }
          this.companiasList.push(objTarjeta); 
        });
      }else{
        this.toastr.error('Ocurrio un error al consultar tarjetas bancarias', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    }, error =>{
      this.companiasList = [];
    })
  }


 
  /* -------------------------------------------------------------------------- */
  /*                               CARGAR PAGINAS                               */
  /* -------------------------------------------------------------------------- */
  setPage(pageInfo) {
    //pageInfo.offset = 0;
    
    this.totalPaginas = (pageInfo.count/pageInfo.limit);
     this.totalSeleccionado = (Number(pageInfo.offset) * Number(pageInfo.count))/ parseInt(this.totalPaginas.toString());

     if(Number(this.totalSeleccionado)>=Number(this.totalPaginas) && Number(this.totalPaginas)>2){
      
      this.totalSeleccionado = this.totalSeleccionado-5
    
     }

 
    this.pageNumber = pageInfo.offset;
  
    if(pageInfo.offset <= 0){

      this.pageNumber =pageInfo.offset;
      this.totalSeleccionado =  0;
      
    }
  

   
    let busqued = "vacio";
    this.tipo == "" ? "RADIOGRAFIA 2D" : this.tipo;
    if (this.buscarServicio != "") {
      busqued = this.buscarServicio;
    }


    this.busquedaOrdenN(busqued);

  }
  
  /* -------------------------------------------------------------------------- */
  /*                                BUSCAR ORDEN                                */
  /* -------------------------------------------------------------------------- */
  busquedaOrdenN(busqueda) {
    this.spinnerBoolean = true;
    this.serviciolist = [];
    this.totalElements = 0;
    var modo = "buscar-servicio"

   
    setTimeout(()=>{                           // <<<---using ()=> syntax
      this.serviciosService.mostrarServicios( localStorage.getItem('token'),  this.size, parseInt(  this.totalSeleccionado.toString()), busqueda, this.tipo == "" ? "RADIOGRAFIA 2D" : this.tipo, modo).subscribe((resp) => {
        if (this.hasApiError(resp)) {
          this.spinnerBoolean = false;
          this.serviciolist = [];
          this.totalElements = 0;
          this.showApiError(resp, 'No se pudo consultar productos/servicios.');
          return;
        }
        this.spinnerBoolean = false;
        this.serviciolist = resp["rows"];
        this.totalElements = resp.total;
      });
  }, 1000);
   

  }


  /* -------------------------------------------------------------------------- */
  /*                        BUSQUEDA FILTRANDO  DATOS                           */
  /* -------------------------------------------------------------------------- */
  updateFilter(event) {
    this.buscarServicio = event.target.value;
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      let busqued = "vacio";
    this.pageNumber = 0;
    this.totalSeleccionado = 0;
    if (this.buscarServicio != "") {

      busqued = event.target.value;
    }

    this.busquedaOrdenN(busqued);
      clearTimeout(this.timeout)
    },1000)
   
  }

  /* -------------------------------------------------------------------------- */
  /*                           CAMBIAR METODOS DE PAGO                          */
  /* -------------------------------------------------------------------------- */
  changeMetodoPago(metodoPago){

    
    Swal.fire({
      icon: 'warning',
      title: '¿Está seguro que desea cambiar el metodo de pago? tendrá que volver a seleccionar los servicios nuevamente',
      text: '¡si no lo está puede cancelar la acción!',
      showCancelButton: true,
      confirmButtonColor: '#0162e8',
      cancelButtonColor: '#FF0000',
      confirmButtonText: 'Si, cambiar!',
      cancelButtonText: 'Cancelar',
      reverseButtons: true

    }).then((result) => {

      if (result.isConfirmed) {
     
        var metodoPagoAnterior =  this.metodosPagos;
        this.metodoPagoV = metodoPago;

        this.metodosPagos = metodoPago;
        this.contenedorDoctor = true;
        let dtOld = this.detalleOrden;
        this.detalleOrden = [];

        this.impuestoTarjeta = 0;
        this.arrayPagos = [];

        let opcionMetodoPago = {
          "EFECTIVO": false,
          "TARJETA DE DEBITO": true,
          "TARJETA DE CREDITO": true,
          "TRANSFERENCIA":false,
          "CREDITO": false
        }

        this.esTarjeta = opcionMetodoPago[metodoPago];

        setTimeout(()=>{               
       
          // <<<---using ()=> syntax
          for(var i = 0; i< dtOld.length; i++){
         
            console.log(dtOld[i].valor);
            var precio = dtOld[i].precioSeleccionado;
            var piezaS = dtOld[i].pieza;
         
            
            var id = dtOld[i].id;
            if(this.metodosPagos == "EFECTIVO" || this.metodosPagos == "TRANSFERENCIA" || this.metodosPagos == "CREDITO"){

              this.serviciosService.mostrarServicios( localStorage.getItem('token'), null, null,id, "COD_PRO", "obtener-servicio-item").subscribe((resp) => {
               
           
                var itemP = this.precioItem(resp.rows[0].CODN_PRO, resp.rows[0].VAL_PRO,resp.rows[0].VAL2_PRO, resp.rows[0].VAL3_PRO, resp.rows[0].VAL4_PRO, resp.rows[0].DER_PRO, resp.rows[0].TIP_PRO, resp.rows[0].preciosLab, resp.rows[0].VALEMP_PRO);
                console.log(itemP);
                let preciosSelect :any[] = [];  
                          preciosSelect.push({
               
                           "precio" :  itemP.split(",")[0],
                           "porcentaje" : "",
               
               
                           },{
               
                             "precio" : itemP.split(",")[1],
                             "porcentaje" : "PRECIO B: ",
               
               
                         },{
               
                             "precio" :  itemP.split(",")[2],
                             "porcentaje" : "PRECIO C: ",
               
               
                         },{
               
                           "precio" : itemP.split(",")[3],
                           "porcentaje" : "PRECIO EST: ",
               
               
                         });

                         
               
                         this.detalleOrden.push({
        
                          id: resp.rows[0].COD_PRO,
                          producto: resp.rows[0].NOM_PRO,
                          codigo : resp.rows[0].CODN_PRO,
                          valor: resp.rows[0].VAL_PRO,
                          pieza: piezaS,
                          agregado: " ",
                          precio1: itemP.split(",")[0],
                          precio2: itemP.split(",")[1],
                          precio3: itemP.split(",")[2],
                          precio4: itemP.split(",")[3],
                          impuesto: resp.rows[0].IMP_PRO,
                          incluidoIva: resp.rows[0].INCLIVA_PRO,
                          precioSeleccionado: itemP.split(",")[0],
                          tipo:resp.rows[0].TIP_PRO,
                          preciosSelect: preciosSelect,
                          reserved: true
                        });   
                       // preciosSelect = [];
                       this.sumarTotalPrecios();

     
                });

                
              
            }else if(this.metodosPagos == 'PAGO MULTIPLE'){
              this.detalleOrden = [];
            }else{

              if(metodoPagoAnterior == "TARJETA DE DEBITO" || metodoPagoAnterior == "TARJETA DE CREDITO"){
                let preciosSelect :any[] = [];  
       

              preciosSelect.push({
  
                "precio" : dtOld[i].precio1,
                "porcentaje" : "",
    
    
                },{
    
                  "precio" : dtOld[i].precio2,
                  "porcentaje" : "PRECIO B: ",
    
              },{
    
                  "precio" :  dtOld[i].precio3,
                  "porcentaje" : "PRECIO C: ",
    
              },{
    
                "precio" :  dtOld[i].precio4,
                "porcentaje" : "PRECIO EST: ",
    
              });
    
  
              var tot = dtOld[i].precioSeleccionado;
           
              this.detalleOrden.push({
    
    
                id: dtOld[i].id,
                producto:  dtOld[i].producto,
                codigo :  dtOld[i].codigo,
                valor:  dtOld[i].valor,
                pieza:   dtOld[i].pieza,
                agregado: " ",
                precio1:  dtOld[i].precio1,
                precio2:  dtOld[i].precio2,
                precio3:  dtOld[i].precio3,
                precio4:  dtOld[i].precio4,
                impuesto:  dtOld[i].impuesto,
                incluidoIva:  dtOld[i].incluidoIva,
                precioSeleccionado:   parseFloat(tot.toString()).toFixed(2),
                tipo: dtOld[i].tipo,
                preciosSelect:  preciosSelect,
                reserved: true
              });



            }else{

    
              let preciosSelect:any =[];
              preciosSelect.push({
  
                "precio" : dtOld[i].precio1 * 1.06,
                "porcentaje" : "",
    
    
                },{
    
                  "precio" : dtOld[i].precio2  * 1.06,
                  "porcentaje" : "PRECIO B: ",
    
              },{
    
                  "precio" :  dtOld[i].precio3  * 1.06,
                  "porcentaje" : "PRECIO C: ",
    
              },{
    
                "precio" :  dtOld[i].precio4  * 1.06,
                "porcentaje" : "PRECIO EST: ",
    
              });
    
  
               tot = dtOld[i].precioSeleccionado*1.06;
           
              this.detalleOrden.push({
    
    
                id: dtOld[i].id,
                producto:  dtOld[i].producto,
                codigo :  dtOld[i].codigo,
                valor:  dtOld[i].valor,
                pieza:   dtOld[i].pieza,
                agregado: " ",
                precio1:  dtOld[i].precio1 *1.06,
                precio2:  dtOld[i].precio2*1.06,
                precio3:  dtOld[i].precio3*1.06,
                precio4:  dtOld[i].precio4*1.06,
                impuesto:  dtOld[i].impuesto,
                incluidoIva:  dtOld[i].incluidoIva,
                precioSeleccionado:   parseFloat(tot.toString()).toFixed(2),
                tipo: dtOld[i].tipo,
                preciosSelect:  preciosSelect,
                reserved: true
              });
              
     

            }

            }


          

          }
          
          this.sumarTotalPrecios();
  
      }, 1000);
      

    
            
         
         

       
        
       

      }

    

    });
  }

  changeRow(index, event) {

    let total = Number(event.target.value);

    this.detalleOrden[index].precioSeleccionado = total;
   
    
    this.sumarTotalPrecios();

  }
  /* -------------------------------------------------------------------------- */
  /*                           VOLVER A LISTA ORDENES                           */
  /* -------------------------------------------------------------------------- */
  volverAtras(){

    this.router.navigateByUrl('sistema/descuentos');

  }

  private esVistaMovil(): boolean {
    return window.matchMedia('(max-width: 767.98px)').matches;
  }

  private abrirModalDocumentos(links: DocumentoFacturaLink[], numFactura: string): void {
    this.docLinks = links;
    this.docNumFactura = numFactura;
    if (this.esVistaMovil()) {
      this.modalService.open(this.mdlDocumentosFacturaRef, {
        backdrop: 'static',
        centered: true,
        windowClass: 'modal-mobile-full'
      });
      return;
    }

    links.forEach((link) => this.abrirDocumentoFactura(link));
    this.router.navigateByUrl('sistema/descuentos');
  }

  abrirDocumentoFactura(link: DocumentoFacturaLink): void {
    const request$ = link.action === 'nodeInternalReceipt'
      ? this.ordenesService.generarReciboInterno(
          localStorage.getItem('token'),
          link.numeroFactura,
          link.tipoFactura,
          link.idOrden
        )
      : link.action === 'nodeCustomerTicket'
        ? this.ordenesService.generarFacturaClienteNode(
            localStorage.getItem('token'),
            link.numeroFactura,
            link.tipoFactura,
            link.idOrden
          )
        : this.ordenesService.generarTicketMuestraLaboratorio(
            localStorage.getItem('token'),
            link.numeroFactura,
            'factura',
            link.tipoFactura,
            link.idOrden
          );

    request$.subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      error: (err) => {
        this.toastr.error('No se pudo abrir el documento: ' + (err?.error?.message || err?.message || 'Error desconocido'));
      }
    });
  }

  irAlInicio(): void {
    this.modalService.dismissAll();
    this.router.navigateByUrl('sistema/descuentos');
  }

  /* -------------------------------------------------------------------------- */
  /*                               BUSCAR PACIENTE                              */
  /* -------------------------------------------------------------------------- */
  buscarPaciente(event: any){
   

    if(event.key.toString() != "ArrowDown" && event.key.toString() != "ArrowUp" && event.key.toString() != "Enter"){

        let paciente = event.target.value;
        this.pacienteslist = [];
        this.pacienteslist.push({
      
          "datos": "Cargando....",
          "codigo":""
        });

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
        
          this.pacientesService.buscarPaciente(  localStorage.getItem('token'),0,0,paciente, "crear-orden").subscribe((resp) => {
            if (this.hasApiError(resp)) {
              this.pacienteslist = [];
              this.showApiError(resp, 'No se pudo consultar pacientes.');
              return;
            }
            this.pacienteslist = [];
            if (resp.total >= 1) {

           
              resp.rows.forEach((currentValue, index) => {

            
      
                this.pacienteslist.push({
      
                  "datos": "CEDULA: "+currentValue.CED_CLI + ", NOMBRE: " + currentValue.NOM_CLI,
                  "codigo": currentValue.COD_CLI
                });
      
              });
            }
      
      
          }, (err) => {
            this.pacienteslist = [];
          })

      
          clearTimeout(this.timeout)
        },1000)

    }
   
  


  }


  /* -------------------------------------------------------------------------- */
  /*                        OBTENER CLIENTE SELECCIONADO                        */
  /* -------------------------------------------------------------------------- */
  async obtenerClienteSeleccionado(name) {

   
    if(this.selected === null || this.selected == ""){

      this.limpiarDataPaciente();
      this.pacienteslist = [];
      return;

    }

    this.pacientesService.mostrarPacientesNormal(localStorage.getItem('token'),"COD_CLI", name).subscribe((resp) => {

     var content = JSON.parse(JSON.stringify(resp.rows));

     this.nombre = content[0].NOM_CLI;
     this.identificacion = content[0].CED_CLI;
     this.telefono = content[0].TEL_CLI;
     this.telefonoClon= content[0].TEL_CLI;
     this.direccion = content[0].DIR_CLI;
     this.fechaNacimiento = content[0].FEC_CLI;
     this.email = content[0].EMA_CLI;
     this.idPaciente = content[0].COD_CLI;
     this.identificacionAdicional = content[0].cedula_cliente,
     this.nombreAdicional = content[0].nombre_cliente
    }, (err) => {
      console.warn('request_error_suppressed', err);
    })

    let validarPendiente: any = await this.validarOrdenPendienteCliente(name, localStorage.getItem('token'));

    if(validarPendiente.operacion && validarPendiente.datos.length > 0){

      this.toastr.error("El paciente tiene ordenes pendientes", 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      this.modalService.open(this.modalOrderPendingPaciente, { 
        size: 'lg',
        backdrop: 'static',
        keyboard: false });

        this._ordersPendingPatient =  validarPendiente.datos;
    }

  }

  /* ------------------------ REDIRECCION EDITAR ORDEN ------------------------ */
  editOrden(codigo){
    this.modalService.dismissAll();
    this.router.navigate(['/sistema/editar-orden', this.makeid(100) + codigo + this.makeid(100)]);
  }


  /* -------------------------------------------------------------------------- */
  /*                            LIMPIAR DATOS DOCTOR                            */
  /* -------------------------------------------------------------------------- */
  limpiarDataDoctor(){

    this.nombreDoctor= "";
    this.cedulaDoctor="";
    this.telefonoDoctor= "";
    this.direccionDoctor="";
    this.emailDoctor= "";
    this.telefonoDoctorClon =  "";
    this.codigoDoctor = "";
    this.asesorDoctor = "";
    this.talonarioDocotorGet = "";
    this.talonarioDocotor ="";
  }
  limpiarDataPaciente(){

    this.nombre = "";
    this.identificacion ="";
    this.telefono = "";
    this.direccion ="";
    this.fechaNacimiento = "";
    this.email ="";
    this.identificacionAdicional = "";
    this.nombreAdicional = "";
  }

  /* -------------------------------------------------------------------------- */
  /*                           MOSTRAR INPUT TELEFONO                           */
  /* -------------------------------------------------------------------------- */
  mostrarInputTelefono(){
    this.mTelefonoDoctor = !this.mTelefonoDoctor;
    if(this.mTelefonoDoctor){

      this.telefono = "";
    }else{

      this.telefono = this.telefonoClon;
      this.nuevoTelefonoEnCardP = "";
    }
  }


  /* -------------------------------------------------------------------------- */
  /*                        ABRIR MODAL AGREGAR PACIENTE                        */
  /* -------------------------------------------------------------------------- */
  modalAgregarPaciente(basicModal:any){

    this.modalService.open(basicModal,{
      backdrop: 'static',
      windowClass: 'modal-mobile-full'
    });



  }


    /* -------------------------------------------------------------------------- */
  /*                        ABRIR MODAL AGREGAR PACIENTE                        */
  /* -------------------------------------------------------------------------- */
  modalAgregarDoctor(basicModal:any){

    this.modalService.open(basicModal,{
      backdrop: 'static'
    });

    this.talonarioDocotor = "10";

  }

  
  /* -------------------------------------------------------------------------- */
  /*                  CAMBIAR A SI SI NO HAS DADO IDENTIFIACION                 */
  /* -------------------------------------------------------------------------- */
  cambiarSIIdent(){

    this.checkIdentificacionNO = false;
    this.checkConsumidorFinalNO = false;
       
    this.identificacionAdicional = "";
    this.nombreAdicional = "";
    this.direccionAdicional ="";
    this.nuevaIdentificacionPacienteOP = ""

  }


  /* -------------------------------------------------------------------------- */
  /*                 CAMBIAR NO SI NO NO HAS DADO IDENTIFIACION                 */
  /* -------------------------------------------------------------------------- */
  cambiarNOIdent(){

    this.checkIdentificacionSI =false;
    var x = Math.floor((Math.random() * 100000000) + 1);
   // this.randomCedula = x.toString();
    var fecha = new Date();

    var codigo = fecha.getDate() + "" + (fecha.getMonth() + 1) + "" + fecha.getFullYear() + "" + fecha.getHours() + "" + x + fecha.getMinutes() + "" + fecha.getSeconds() + "" + fecha.getMilliseconds();
    this.randomCedula = codigo.substring(0, 13);
    this.nombrePaciente = "";
    this.fechaNacimientoPaciente ="";
    this.direccionPaciente = "";
    this.sexoPaciente = "";
    this.identificacionPaciente = "";
    this.checkConsumidorFinalNO = true;

       
    this.identificacionAdicional = "9999999999999";
    this.nombreAdicional = "CONSUMIDOR FINAL";
    this.direccionAdicional ="GUAYAQUIL";
    this.nuevaIdentificacionPacienteOP = "07"

  }


  /* -------------------------------------------------------------------------- */
  /*                   CAMBIA HA SI SI NOS HA DADO EL TELEFONO                  */
  /* -------------------------------------------------------------------------- */
  cambiarSITelef(){

    this.checkTelefonoNO = false;
    this.inputMaskPais =  this.pais.split("|")[2];
    this.nuevoTelefonoCliente = this.pais.split("|")[1]+" "
  }


  /* -------------------------------------------------------------------------- */
  /*                 CAMBIAR HA NO SI NO NOS HA DADO EL TELEFONO                */
  /* -------------------------------------------------------------------------- */
  cambiarNOTelf(){

    this.checkTelefonoSI =false;

  
  }


  /* -------------------------------------------------------------------------- */
  /*                         CHECK FACTURAR OTRA PERSONA                        */
  /* -------------------------------------------------------------------------- */
  cambiarFacturarOtraPersona(){

    if(this.checkFacturarOtrasPersonasSI){
      this.checkConsumidorFinalNO = false;
      this.identificacionAdicional = "";
      this.nombreAdicional = "";
      this.direccionAdicional ="GUAYAQUIL";
      this.nuevaIdentificacionPacienteOP = "05"
    } else {
      if(this.checkIdentificacionNO){
        this.checkFacturarOtrasPersonasSI = true;
      }
    }
  }


  /* -------------------------------------------------------------------------- */
  /*                       CHECK CAMBIAR CONSUMIDOR FINAL                       */
  /* -------------------------------------------------------------------------- */
  cambiarConsumidorFinal(){

    if(this.checkConsumidorFinalNO){
      this.checkFacturarOtrasPersonasSI = false;
      this.identificacionAdicional = "9999999999999";
      this.nombreAdicional = "CONSUMIDOR FINAL";
      this.direccionAdicional ="GUAYAQUIL";
      this.nuevaIdentificacionPacienteOP = "07"
    } else {
      if(this.checkIdentificacionNO){
        this.checkConsumidorFinalNO = true;
      } else {
        this.identificacionAdicional = "";
        this.nombreAdicional = "";
        this.direccionAdicional ="";
        this.nuevaIdentificacionPacienteOP = ""
      }
    }

  }


  validarCedulaEcuatoriana(cedula: string): boolean {
    if (!cedula || cedula.length !== 10 || !/^\d{10}$/.test(cedula)) return false;
    const provincia = parseInt(cedula.substring(0, 2));
    if (provincia < 1 || (provincia > 24 && provincia !== 30)) return false;
    if (parseInt(cedula[2]) >= 6) return false;
    const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
    let suma = 0;
    for (let i = 0; i < 9; i++) {
      let val = parseInt(cedula[i]) * coeficientes[i];
      if (val >= 10) val -= 9;
      suma += val;
    }
    const residuo = suma % 10;
    const digitoEsperado = residuo === 0 ? 0 : 10 - residuo;
    return parseInt(cedula[9]) === digitoEsperado;
  }

  /* -------------------------------------------------------------------------- */
  /*                            BUSCAR DATA PERSONAS                            */
  /* -------------------------------------------------------------------------- */
  buscarDataPersonas(tipo){

    if(this.nuevaIdentificacionPaciente === "05"){
      if(!this.validarCedulaEcuatoriana(this.identificacionPaciente)){
        this.toastr.error('La cédula ingresada no es válida', 'Cédula incorrecta', {
          timeOut: 5000,
          closeButton: true,
          progressBar: true
        });
        return;
      }
    }

    this.pacientesService.mostrarPacientesNormal(localStorage.getItem('token'),"CED_CLI", this.identificacionPaciente).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));
 
       if(Number(content.length)>0 && tipo == "agregar"){

          this.identificacionPaciente = "";
            
          this.toastr.error('La identificación que ingresó ya se encuentra registrado, puede buscarlo en el campo de  buscar en la sección paciente', 'Atención', {
            timeOut: 9000,
            closeButton: true,
            progressBar: true
          });


       }else{


        if(this.nuevaIdentificacionPaciente == "04"){

          this.spinnerBooleanBuscarData= true;
          this.pacientesService.buscarDataPersonaRUC(
            this.identificacionPaciente,
          ).subscribe((resp) => {
      
            this.spinnerBooleanBuscarData= false;
            var content = JSON.parse(resp);
          
            this.nombrePaciente = content[0].razonsocial;
           
      
          });
    
        
        }else{
    
          this.spinnerBooleanBuscarData= true;
          this.pacientesService.buscarDataPersona(
            this.identificacionPaciente,
          ).subscribe((resp) => {
      
            this.spinnerBooleanBuscarData= false;
            var content = JSON.parse(resp);
          
            this.nombrePaciente = content.nombreCompleto;
            this.fechaNacimientoPaciente = content.fechaNacimiento;
            this.direccionPaciente = content.domicilio;
            this.sexoPaciente = content.sexo;
            this.nuevaEdadPaciente =  this.calcularEdad(this.fechaNacimientoPaciente).toString();
            this.infoAdicional = content.infoAdicional;
          });
        }

       }
     }, (err) => {
       console.warn('request_error_suppressed', err);
     })

    

   

  }

  

  /* -------------------------------------------------------------------------- */
  /*                       BUSCAR DATA PERSONAS ADICIONAL                       */
  /* -------------------------------------------------------------------------- */
  buscarDataPersonasAdicional(){

    if(this.nuevaIdentificacionPacienteOP == "04"){

      this.spinnerBooleanBuscarDataAdicional= true;
      this.pacientesService.buscarDataPersonaRUC(
        this.identificacionAdicional,
      ).subscribe((resp) => {
  
        this.spinnerBooleanBuscarDataAdicional= false;
        var content = JSON.parse(resp);
      
        this.nombreAdicional = content[0].razonsocial;
       
  
      });

    
    }else{

        this.spinnerBooleanBuscarDataAdicional= true;
        this.pacientesService.buscarDataPersona(
          this.identificacionAdicional,
        ).subscribe((resp) => {

          this.spinnerBooleanBuscarDataAdicional= false;
          var content = JSON.parse(resp);
        
          this.nombreAdicional = content.nombreCompleto;
          this.direccionAdicional = content.domicilio;
        
        });
    }
  }


  /* -------------------------------------------------------------------------- */
  /*                               MOSTRAR PAISES                               */
  /* -------------------------------------------------------------------------- */
  mostrarPaises(){

    
    this.paisesService.mostrarPaises(
      localStorage.getItem('token'),
      null,
      null
    ).subscribe((resp) => {

      this.paisesList = [];

      resp.rows.forEach((currentValue, index) => {

        this.paisesList.push({

            "nombre" : currentValue.NOM_PAIS,
            "id" : currentValue.COD_PAIS,
            "codigo" : currentValue.CODE_PAIS,
            "imagen" : `/assets${currentValue.RUT_PAIS}`,
            "estructura" : currentValue.STRUC_PAIS

        });

      });
    });

  }


  /* -------------------------------------------------------------------------- */
  /*                                CAMBIAR PAIS                                */
  /* -------------------------------------------------------------------------- */
  cambiarPais(){

    this.inputMaskPais =  this.pais.split("|")[2];
    this.nuevoTelefonoCliente = this.pais.split("|")[1]+" "

  }
  

  /* -------------------------------------------------------------------------- */
  /*                              GUARDAR PACIENTE                              */
  /* -------------------------------------------------------------------------- */
  guardarPaciente(){

    if(this.checkIdentificacionSI){

        if(this.nuevaIdentificacionPaciente==""){

            this.toastr.error('Seleccione el tipo de identificación del paciente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

            return;
        }


        if(this.identificacionPaciente==""){

            this.toastr.error('Ingrese identificación del paciente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

            return;
        }
    }

    if(this.checkIdentificacionNO){


      this.identificacionPaciente = this.randomCedula;
    }
    if(this.nombrePaciente==""){

        this.toastr.error('Ingrese nombre del paciente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        return;
    }

    if(this.fechaNacimientoPaciente==""){

        this.toastr.error('Ingrese fecha nacimiento del paciente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        return;
    }

    if(this.sexoPaciente==""){

      this.toastr.error('Ingrese sexo Paciente', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });

      return;
  }

  if(this.nuevaEdadPaciente==""){

    this.toastr.error('Ingrese edad del paciente', 'Atención', {
      timeOut: 3000,
      closeButton: true,
      progressBar: true
    });

    return;
}




    if(this.checkTelefonoSI){

       if(this.nuevoTelefonoCliente==""){


          this.toastr.error('Ingrese teléfono del paciente', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;

       }

       if(this.pais.split("|")[1]=='593'){
        if(this.nuevoTelefonoCliente.trim().length < 12){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='58'){
        if(this.nuevoTelefonoCliente.trim().length < 11){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='1'){
        if(this.nuevoTelefonoCliente.trim().length < 11){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='51'){
        if(this.nuevoTelefonoCliente.trim().length < 10){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='03'){
        if(this.nuevoTelefonoCliente.trim().length < 12){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }
   
       if(this.pais.split("|")[1]==this.nuevoTelefonoCliente.replace("(","").replace(")", "").trim()){

        this.toastr.error('Ingrese teléfono del paciente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        return;

       }
     
    }

    if(this.nuevoEmailPaciente == ""){

         this.nuevoEmailPaciente = "cmsalud.manager@gmail.com";
    }

    if(this.direccionPaciente==""){

        this.direccionPaciente = "GUAYAQUIL";
        
    }

    if(this.checkFacturarOtrasPersonasSI){

        if(this.nuevaIdentificacionPacienteOP==""){

          this.toastr.error('Ingrese identificación adicional a facturar', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;
        }

        if(this.nombreAdicional==""){

          this.toastr.error('Ingrese nombre adicional a facturar', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;
        }

        if(this.direccionAdicional==""){

           this.direccionAdicional = "SN";
        }
    }
    
    this.guardarPac = true;
    
    this.spinnerBooleanBuscarData = true;
    this.pacientesService.guardarPaciente(
      this.nuevaIdentificacionPaciente,
      this.identificacionPaciente,
      this.fechaNacimientoPaciente,
      this.pais,
      this.nuevoTelefonoCliente,
      
      this.nuevoEmailPaciente, 
      this.direccionPaciente,
      this.sexoPaciente,
      this.nuevaEdadPaciente,
      this.nuevaIdentificacionPacienteOP,
      this.identificacionAdicional,
      this.nombreAdicional,
      this.direccionAdicional,
      localStorage.getItem('token'),
      this.nombrePaciente,
      this.checkIdentificacionSI ? "si" : "no",
      JSON.stringify(this.infoAdicional)
    ).subscribe((resp) => {

      if(resp=="ok"){
        this.spinnerBooleanBuscarData = false;
        this.toastr.success('Paciente ingresado correctamanete', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.cerrarModalDoctor1();
        this.pacientesService.mostrarPacientesNormal(localStorage.getItem('token'),"CED_CLI",    this.identificacionPaciente,).subscribe((resp) => {

          var content = JSON.parse(JSON.stringify(resp.rows));
     
          this.nombre = content[0].NOM_CLI;
          this.identificacion = content[0].CED_CLI;
          this.telefono = content[0].TEL_CLI;
          this.telefonoClon= content[0].TEL_CLI;
          this.direccion = content[0].DIR_CLI;
          this.fechaNacimiento = content[0].FEC_CLI;
          this.email = content[0].EMA_CLI;
          this.idPaciente = content[0].COD_CLI;

          this.guardarPac = false;
        
         }, (err) => {

           this.toastr.success(err.message, 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
           this.guardarPac = false;
         })

      }else{
      
        this.toastr.error(resp, 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
          
      }

    });


    
  }


  /* -------------------------------------------------------------------------- */
  /*                                CALCULAR EDAD                               */
  /* -------------------------------------------------------------------------- */
  calcularEdad(fecha) {
    var hoy = new Date();
    var cumpleanos = new Date(fecha);
    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
    var m = hoy.getMonth() - cumpleanos.getMonth();

    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
    }

    return edad;
  }


  /* -------------------------------------------------------------------------- */
  /*                          CAMBIAR FECHA NACIEMITNO                          */
  /* -------------------------------------------------------------------------- */
  cambiarFechaNacimiento(){

    this.nuevaEdadPaciente =  this.calcularEdad(this.fechaNacimientoPaciente).toString();
  }


  /* -------------------------------------------------------------------------- */
  /*                            MODAL EDITAR PACIENTE                           */
  /* -------------------------------------------------------------------------- */
  modalEditarPaciente(basicModal:any){

    this.modalService.open(basicModal,{
      backdrop: 'static',
      windowClass: 'modal-mobile-full'
    });


    this.pacientesService.mostrarPacientesNormal(localStorage.getItem('token'),"COD_CLI",    this.idPaciente,).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));
       this.randomCedula = content[0].CHECKCED_CLI == "no" ? content[0].CED_CLI : "";
      this.nuevaIdentificacionPaciente = content[0].TIPIDEN_CED;
      if(content[0].CHECKCED_CLI == null  || content[0].CHECKCED_CLI == ""){



          if(content[0].CED_CLI.length == 10){

            this.nuevaIdentificacionPaciente = '05';
            this.checkIdentificacionSI = true;
          }

          if(content[0].CED_CLI.length == 13){

            this.nuevaIdentificacionPaciente = '04';

            this.checkIdentificacionSI = true;
          }


      }else{
        this.checkIdentificacionSI = content[0].CHECKCED_CLI == "si" ? true :false;;
        this.checkIdentificacionNO = content[0].CHECKCED_CLI == "no" ? true :false;;
     
      }
      this.identificacionPaciente = content[0].CED_CLI;
      this.fechaNacimientoPaciente =content[0].FEC_CLI;
      this.pais = content[0].FORMTEL_CLI;
      if(this.pais!=null){

        this.inputMaskPais =  this.pais.split("|")[2]; 
      }else{

        if(content[0].CODPAIS_CLI == "593"){

           this.pais =  "3|593|(000) 00 0000 000";
           this.inputMaskPais =  this.pais.split("|")[2]; 
        }

        if(content[0].CODPAIS_CLI == "58"){

          this.pais =  "4|58|(00) 000 0000 00";
          this.inputMaskPais =  this.pais.split("|")[2]; 
        }

        if(content[0].CODPAIS_CLI == "1"){

          this.pais =  "5|1|(0) 000 0000 000";
          this.inputMaskPais =  this.pais.split("|")[2]; 
        }

        if(content[0].CODPAIS_CLI == "51"){

          this.pais =  "6|51|(00) 00 000 000";
          this.inputMaskPais =  this.pais.split("|")[2]; 
        }

        if(content[0].CODPAIS_CLI == "03"){

          this.pais =  "7|03|(00) 000 0000 000";
          this.inputMaskPais =  this.pais.split("|")[2]; 
        }
       
      }
  
      this.checkTelefonoSI =  content[0].TEL_CLI.length>5 ? true : false
      this.checkTelefonoNO=  content[0].TEL_CLI.length<5 ? true : false
      this.nuevoTelefonoCliente = content[0].TEL_CLI;
      this.nuevoEmailPaciente = content[0].EMA_CLI;
      this.direccionPaciente = content[0].DIR_CLI;
      this.sexoPaciente =  content[0].SEX_CLI;
      this.nuevaEdadPaciente = content[0].EDAD_CLI;
      this.identificacionAdicional = content[0].cedula_cliente;
      this.nombreAdicional = content[0].nombre_cliente;
      this.direccionAdicional = content[0].direccion_cliente;
      this.nombrePaciente = content[0].NOM_CLI;
      this.nuevaIdentificacionPacienteOP = content[0].tipoiden_cliente;
      if(content[0].tipoiden_cliente == null || content[0].tipoiden_cliente == ""){

        if(content[0].cedula_cliente == "9999999999999"){

          this.nuevaIdentificacionPacienteOP = '07';
        }

      }
      this.checkFacturarOtrasPersonasSI = content[0].cedula_cliente != "9999999999999" && content[0].cedula_cliente != '' && content[0].cedula_cliente != null ? true : false;;
      this.checkConsumidorFinalNO = content[0].cedula_cliente == "9999999999999" ? true : false;
      
     }, (err) => {
       console.warn('request_error_suppressed', err);
     })
   
  }

  
  /* -------------------------------------------------------------------------- */
  /*                                CERRAR MODAL                                */
  /* -------------------------------------------------------------------------- */
  cerrarModal(){

    this.modalService.dismissAll();
    this.checkIdentificacionSI = false;
    this.checkIdentificacionNO = false;
    this.nuevaIdentificacionPaciente = "";
    this.identificacionPaciente = "";
    this.fechaNacimientoPaciente = "";
    this.pais = "";
    this.nuevoTelefonoCliente = ""; 
    this.nuevoEmailPaciente = "cmsalud.manager@gmail.com"; 
    this.direccionPaciente = "";
    this.sexoPaciente = "";
    this.nuevaEdadPaciente = "";
    this.nuevaIdentificacionPacienteOP = "";
    this.identificacionAdicional = "";
    this.nombreAdicional = "";
    this.direccionAdicional = "";
    this.nombrePaciente = "";
    this.checkIdentificacionSI = false;  
    this.checkFacturarOtrasPersonasSI = false;
    this.checkConsumidorFinalNO = false;
    this.checkTelefonoSI = false;
    this.checkTelefonoNO = false;
  
  }


  /* -------------------------------------------------------------------------- */
  /*                               EDITAR PACIENTE                              */
  /* -------------------------------------------------------------------------- */
  editarPaciente(){

    if(this.checkIdentificacionSI){

        if(this.nuevaIdentificacionPaciente==""){

            this.toastr.error('Seleccione el tipo de identificación del paciente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

            return;
        }


        if(this.identificacionPaciente==""){

            this.toastr.error('Ingrese identificación del paciente', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

            return;
        }
    }

    if(this.checkIdentificacionNO){


      this.identificacionPaciente = this.randomCedula;
    }
    if(this.nombrePaciente==""){

        this.toastr.error('Ingrese nombre del paciente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        return;
    }

    if(this.fechaNacimientoPaciente==""){

        this.toastr.error('Ingrese fecha nacimiento del paciente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        return;
    }

    if(this.checkTelefonoSI){

       if(this.nuevoTelefonoCliente==""){


          this.toastr.error('Ingrese teléfono del paciente', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;

       }

       if(this.pais.split("|")[1]=='593'){
        if(this.nuevoTelefonoCliente.trim().length < 12){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='58'){
        if(this.nuevoTelefonoCliente.trim().length < 11){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='1'){
        if(this.nuevoTelefonoCliente.trim().length < 11){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='51'){
        if(this.nuevoTelefonoCliente.trim().length < 10){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

       if(this.pais.split("|")[1]=='03'){
        if(this.nuevoTelefonoCliente.trim().length < 12){
          this.toastr.error('Ingrese un número de telefono valido', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }
       }

   
       if(this.pais.split("|")[1]==this.nuevoTelefonoCliente.replace("(","").replace(")", "").trim()){

        this.toastr.error('Ingrese teléfono del paciente', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        return;

       }
     
    }

    if(this.nuevoEmailPaciente == ""){

         this.nuevoEmailPaciente = "cmsalud.manager@gmail.com";
    }

    if(this.direccionPaciente==""){

        this.direccionPaciente = "GUAYAQUIL";
        
    }

    if(this.checkFacturarOtrasPersonasSI){

        if(this.nuevaIdentificacionPacienteOP==""){

          this.toastr.error('Ingrese identificación adicional a facturar', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;
        }

        if(this.nombreAdicional==""){

          this.toastr.error('Ingrese nombre adicional a facturar', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;
        }

        if(this.direccionAdicional==""){

          this.direccionAdicional = "SN";
        }
    }

    this.guardarPac = true;

   this.pacientesService.editarPaciente(
      this.nuevaIdentificacionPaciente,
      this.identificacionPaciente,
      this.fechaNacimientoPaciente,
      this.pais,
      this.nuevoTelefonoCliente,
      
      this.nuevoEmailPaciente, 
      this.direccionPaciente,
      this.sexoPaciente,
      this.nuevaEdadPaciente,
      this.nuevaIdentificacionPacienteOP,
      this.identificacionAdicional,
      this.nombreAdicional,
      this.direccionAdicional,
      localStorage.getItem('token'),
      this.nombrePaciente,
      this.checkIdentificacionSI ? "si" : "no",
      this.idPaciente
    ).subscribe((resp) => {

      if(resp=="ok"){

        this.toastr.success('Paciente ingresado correctamanete', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.pacientesService.mostrarPacientesNormal(localStorage.getItem('token'),"CED_CLI",    this.identificacionPaciente,).subscribe((resp) => {

          var content = JSON.parse(JSON.stringify(resp.rows));
     
          this.nombre = content[0].NOM_CLI;
          this.identificacion = content[0].CED_CLI;
          this.telefono = content[0].TEL_CLI;
          this.telefonoClon= content[0].TEL_CLI;
          this.direccion = content[0].DIR_CLI;
          this.fechaNacimiento = content[0].FEC_CLI;
          this.email = content[0].EMA_CLI;
          this.idPaciente = content[0].COD_CLI;

          this.guardarPac = false;

         }, (err) => {
    
           this.toastr.error(err.message, 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
           this.guardarPac = false;

         })

      }else{

        this.toastr.error(resp, 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
          
      }

    });


    
  }


  /* -------------------------------------------------------------------------- */
  /*                                BUSCAR DOCTOR                               */
  /* -------------------------------------------------------------------------- */
  buscarDoctor(event: any){
   

    if(event.key.toString() != "ArrowDown" && event.key.toString() != "ArrowUp" && event.key.toString() != "Enter"){

        let doctor = event.target.value;
        this.doctoreslist = [];
        this.doctoreslist.push({
      
          "datos": "Cargando....",
          "codigo":""
        });

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
        
          this.doctoresService.buscarDoctor(  localStorage.getItem('token'),0,0,doctor, "crear-orden").subscribe((resp) => {
            if (this.hasApiError(resp)) {
              this.doctoreslist = [];
              this.showApiError(resp, 'No se pudo consultar doctores.');
              return;
            }
            this.doctoreslist = [];
            if (resp.total >= 1) {

           
      
              resp.rows.forEach((currentValue, index) => {

            
      
                this.doctoreslist.push({
      
                  "datos": "CEDULA: "+currentValue.CodVendedor + ", NOMBRE: " + currentValue.NombreVendedor,
                  "codigo": currentValue.COD_VEN
                });
      
              });
            }
      
      
          }, (err) => {
            this.doctoreslist = [];
          })

      
          clearTimeout(this.timeout)
        },1000)

    }
   
  


  }



  /* -------------------------------------------------------------------------- */
  /*                        OBTENER CLIENTE SELECCIONADO                        */
  /* -------------------------------------------------------------------------- */
  obtenerDoctorSeleccionado(name) {

   
    if(this.selectedDoctor === null || this.selectedDoctor == ""){

      this.limpiarDataDoctor();
      this.doctoreslist = [];
      return;

    }

    this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'),"COD_VEN", name).subscribe((resp) => {

     var content = JSON.parse(JSON.stringify(resp.rows));
     if(content[0].activarConvenio == "1" || content[0].activarConvenio == 1){

          Swal.fire({
            title: 'Doctor con convenio',
            text: "El doctor seleccionado tiene un convenio activo, desea continuar con la orden sin factura?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar!',
            cancelButtonText: 'No, cancelar!' 
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigateByUrl('sistema/crear-orden-sin-factura');
            }else{
              this.limpiarDataDoctor();
              this.doctoreslist = [];
            }
          })
     }
     this.nombreDoctor= content[0].NombreVendedor;
     this.cedulaDoctor= content[0].CedulaRuc;
     this.telefonoDoctor= content[0].TelefonoMovil;
     this.direccionDoctor= content[0].Direccion;
     this.emailDoctor= content[0].DireccionCorreo;
     this.telefonoDoctorClon =  content[0].TelefonoMovil;
     this.codigoDoctor = content[0].CodVendedor;
     this.asesorDoctor = content[0].UsuarioAsignado;
     this.talonarioDocotorGet = content[0].Abreviatura;
     this.talonarioDocotor = content[0].Abreviatura;
    
    }, (err) => {
      console.warn('request_error_suppressed', err);
    })

  }


  /* ------------------------------------------------------------------(-------- */
  /*                    CAMBIAR ESTADO BUTTON TELEFONO DOCTOR                   */
  /* -------------------------------------------------------------------------- */
  cambiarEstadoEdiTelDoc(){

    this.editarTelefonoDoctor =  !this.editarTelefonoDoctor;
    if(this.editarTelefonoDoctor){
      this.telefonoDoctor = "";
    
    }else{

      this.telefonoDoctor = this.telefonoDoctorClon;
      this.nuevoTelefonoEnCardD = "";
    }
  }
  


  /* -------------------------------------------------------------------------- */
  /*                            BUSCAR DATA PERSONAS                            */
  /* -------------------------------------------------------------------------- */
  buscarDataPersonasDoctor(tipo){



    this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'),"CedulaRuc", this.identificacionDoctor).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));
 
       if(Number(content.length)>0){

          this.identificacionDoctor = "";
            
          this.toastr.error('La identificación que ingresó ya se encuentra registrado, puede buscarlo en el campo de  buscar en la sección doctor', 'Atención', {
            timeOut: 9000,
            closeButton: true,
            progressBar: true
          });


       }else{


      
    
          this.spinnerBooleanBuscarData= true;
          this.pacientesService.buscarDataPersona(
            this.identificacionDoctor,
          ).subscribe((resp) => {
      
            this.spinnerBooleanBuscarData= false;
            var content = JSON.parse(resp);
          
            this.nuevoNombreDoctor = content.nombreCompleto;
            this.nuevaFechaNDoctor = content.fechaNacimiento;
            this.nuevaDireccionDoctor = content.domicilio;
            this.nuevoSexoDoctor = content.sexo;
            this.nuevaEdadDoctor =  this.calcularEdad(this.nuevaFechaNDoctor).toString();
          });
        

       }
     }, (err) => {
       console.warn('request_error_suppressed', err);
     })

    

   

  }


  /* -------------------------------------------------------------------------- */
  /*                        OBTENER ESPECIALIDADES DOCTOR                       */
  /* -------------------------------------------------------------------------- */
  especialidadesDoctor(){

    this.doctoresService.especialidadesDoctor(localStorage.getItem('token'),null,null,null,null).subscribe((resp) => {
      if (this.hasApiError(resp)) {
        this.especialidadesList = [];
        this.showApiError(resp, 'No se pudieron cargar especialidades de doctor.');
        return;
      }
           
      this.especialidadesList = [];
    
        resp.rows.forEach((currentValue, index) => {

      

          this.especialidadesList.push({

            "datos": currentValue.NOM_DOCESP,
            "codigo": currentValue.COD_DOCESP
          });

        });
      


    }, (err) => {
      this.especialidadesList = [];
    })
  }


  /* -------------------------------------------------------------------------- */
  /*                            OBTENER EDAD DOCTOR>                            */
  /* -------------------------------------------------------------------------- */
  cambiarFechaNacimientoDoctor(){

    this.nuevaEdadDoctor =  this.calcularEdad(this.nuevaFechaNDoctor).toString();
  }


  /* -------------------------------------------------------------------------- */
  /*                               GUARDAR DOCTOR                               */
  /* -------------------------------------------------------------------------- */
  guardarDoctor(){

    if(this.identificacionDoctor==""){

        this.toastr.error("Ingrese identificación doctor", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });

        return;

    }

    if(this.nuevoNombreDoctor==""){

        this.toastr.error("Ingrese nombre doctor", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });

        return;
      
    }

    if(this.nuevaFechaNDoctor==""){

      this.toastr.error("Ingrese fecha nacimiento doctor", 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      return;
    
    }


    if(this.nuevoTelefonoDoctor==""){

      this.toastr.error("Ingrese teléfono doctor", 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      return;
    
    }

    
    if(this.nuevoEmailDoctor==""){

      this.toastr.error("Ingrese email doctor", 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      return;
    
    }


    if(this.nuevaDireccionDoctor==""){

      this.toastr.error("Ingrese dirección doctor", 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      return;
    
    }


    if(this.especialidaDoctor==""){

      this.toastr.error("Ingrese especialidad doctor", 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      return;
    
    }

    
    
    this.spinnerBooleanBuscarData = true;
    this.contadorG++;
    this.guardarPac = true;

    if(this.contadorG==1){

      this.doctoresService.guardarDoctor(
        this.identificacionDoctor,
        this.nuevoNombreDoctor,
        this.nuevaFechaNDoctor,
        this.nuevoTelefonoDoctor,
        this.nuevoEmailDoctor,
        
        this.nuevaDireccionDoctor, 
        this.nuevoSexoDoctor,
        this.nuevaEdadDoctor,
        this.bancoDoctor,
        this.cuentaDoctor,
        this.talonarioDocotor,
        this.especialidaDoctor,
        localStorage.getItem('token'),
      ).subscribe((resp) => {

        //var texto = "Buenas tardes dr (a)😷 "+this.nuevoNombreDoctor+" un gusto en saludar de parte de *C&M Radiografías y Tomografías Dentales, Ecografias y Laboratorio Clinico*, es para informarle que tenemos el app💪 para generar ORDENES DIGITALES, para lo cual su usuario: # de cedula y su contrasena: "+codigoD+" por favor alguna novedad 😱 o requiere saber el funcionamiento me comunica, solo en telefonos \n*ANDROID:*\nhttps://play.google.com/store/apps/details?id=com.cm.radiografia \n*IOS:*\nhttps://apps.apple.com/us/app/c-m-doctores/id1565066791?l=es";
                                                      
      this.doctoresService.enviarNotificacionDoctor(
        this.nuevoTelefonoDoctor,
        this.identificacionDoctor,
        localStorage.getItem('token'),



        ).subscribe((resp) => {

        });

  
        if(resp=="ok"){
          this.spinnerBooleanBuscarData = false;
          this.toastr.success('Paciente ingresado correctamanete', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          this.modalService.dismissAll();
     
          this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'),"CedulaRuc", this.identificacionDoctor).subscribe((resp) => {
  
            var content = JSON.parse(JSON.stringify(resp.rows));
            this.nombreDoctor= content[0].NombreVendedor;
            this.cedulaDoctor= content[0].CedulaRuc;
            this.telefonoDoctor= content[0].TelefonoMovil;
            this.direccionDoctor= content[0].Direccion;
            this.emailDoctor= content[0].DireccionCorreo;
            this.telefonoDoctorClon =  content[0].TelefonoMovil;
            this.codigoDoctor = content[0].CodVendedor;
            this.asesorDoctor = content[0].UsuarioAsignado;
            this.contadorG = 0;
            this.toastr.success('Paciente ingresado correctamanete', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
            this.guardarPac = false;
           
           }, (err) => {

             this.toastr.success(err.message, 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });
             this.guardarPac = false;
           })
  
        }else{
          this.spinnerBooleanBuscarData = false;
          this.toastr.error(resp, 'Atención', {
            timeOut: 9000,
            closeButton: true,
            progressBar: true
          });

          this.contadorG = 0;
          this.guardarPac = false;
        }
  
      });

    }else{

          this.toastr.error("Ya presionó el boton de guardar una vez por favor espera la respuesta, caso contrario contacte administrador.", 'Atención', {
            timeOut: 9000,
            closeButton: true,
            progressBar: true
          });
          this.guardarPac = false;
    }

 




  }


    
  /* -------------------------------------------------------------------------- */
  /*                             CERRAR MODAL DOCTOR                            */
  /* -------------------------------------------------------------------------- */
  cerrarModalDoctor(){

    this.modalService.dismissAll();
    this.nuevoNombreDoctor = "";
    this.nuevaFechaNDoctor = "";
    this.nuevoTelefonoDoctor = "";
    this.nuevoEmailDoctor = "cmsalud.manager@gmail.com";
    this.nuevaDireccionDoctor = "GUAYAQUIL";
    this.nuevoSexoDoctor = "";
    this.nuevaEdadDoctor = "";
    this.bancoDoctor = "ESTUDIANTE";
    this.cuentaDoctor = "ESTUDIANTE";

    this.nuevaIdentificacionDoctor = "05";
    this.identificacionDoctor  ="";
    this.especialidaDoctor  = "";
    this.mostrarModal = false;
    this.dime2 = false;
    this.dime3 = false;
    this.dime1 = false;
    this.dime4 = false;
    this.cbxPrecioSugerido = false;
    this.cbxCuponDescuento = false;
    this.txtPreciosDisponibles = "";
    this.precioSugerido = "PRECIO SUGERIDO"
    this.txtPrecioSugerido = "";
    this.txtCuponDescuento = ""
    this.dtTrigger.unsubscribe();
    location.reload();
  }


  

    
  /* -------------------------------------------------------------------------- */
  /*                             CERRAR MODAL DOCTOR                            */
  /* -------------------------------------------------------------------------- */
  cerrarModalDoctor1(){

    this.modalService.dismissAll();
    this.nuevoNombreDoctor = "";
    this.nuevaFechaNDoctor = "";
    this.nuevoTelefonoDoctor = "";
    this.nuevoEmailDoctor = "cmsalud.manager@gmail.com";
    this.nuevaDireccionDoctor = "GUAYAQUIL";
    this.nuevoSexoDoctor = "";
    this.nuevaEdadDoctor = "";
    this.bancoDoctor = "ESTUDIANTE";
    this.cuentaDoctor = "ESTUDIANTE";

    this.nuevaIdentificacionDoctor = "05";
    this.identificacionDoctor  ="";
    this.especialidaDoctor  = "";
    this.mostrarModal = false;
    this.dime2 = false;
    this.dime3 = false;
    this.dime1 = false;
    this.dime4 = false;
    this.cbxPrecioSugerido = false;
    this.cbxCuponDescuento = false;
    this.txtPreciosDisponibles = "";
    this.precioSugerido = "PRECIO SUGERIDO"
    this.txtPrecioSugerido = "";
    this.dtTrigger.unsubscribe();
    this.companiaBancaria = "";
   
  }


  /* -------------------------------------------------------------------------- */
  /*                        ABRIR MODAL SOLICITUD ORDENES                       */
  /* -------------------------------------------------------------------------- */
  modalSolicitarOF(basicModal:any){

    if(this.checkSolicitarOrdn && this.nombreDoctor!=""){
      this.modalService.open(basicModal,{
        backdrop: 'static'
      });
  

    }else{
      this.checkSolicitarOrdn= false;
      this.toastr.error("Seleccione un doctor previamente", 'Atención', {
        timeOut: 4000,
        closeButton: true,
        progressBar: true
      });

      return;
         
    }



  }


  /* -------------------------------------------------------------------------- */
  /*                            GUARDAR REQUERIMIENTO                           */
  /* -------------------------------------------------------------------------- */
  guardarSolicitudOF(){
  
    this.spinnerBooleanBuscarData = true;
    this.guardarPac = true;
    this.doctoresService.guardarRequerimiento(
      this.nuevaDescripcionSolicitdOF,
      this.codigoDoctor,
      localStorage.getItem('token'),
    ).subscribe((resp) => {
  
      this.spinnerBooleanBuscarData = false;

        if(resp == "ok"){

          this.doctoresService.enviarNotificacion(
            this.nuevaDescripcionSolicitdOF,
            this.nombreDoctor,
            this.asesorDoctor,
            localStorage.getItem('token'),
          ).subscribe((resp) => {

            this.guardarPac = false;
            this.modalService.dismissAll();

            this.toastr.success("Solicitud generada correctamente", 'Atención', {
              timeOut: 4000,
              closeButton: true,
              progressBar: true
            });
          });
          

          

        }else{
          this.guardarPac = false;
          this.toastr.error(resp, 'Atención', {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          });
        }

    });

  }


  /* -------------------------------------------------------------------------- */
  /*                     ABRIR MODAL SOLICITUD CAPACITACION                     */
  /* -------------------------------------------------------------------------- */
  modalSolicitarCapacitacion(basicModal:any){

    this.modalService.open(basicModal,{
      backdrop: 'static'
    });
  
  }

  /* -------------------------------------------------------------------------- */
  /*                              CHECK TOMOGRAFIA                              */
  /* -------------------------------------------------------------------------- */
  cambiaItem1(tipo){

      if(this.checkTomografia){

         this.concatSolicitud += tipo + ", ";

      }else{


        this.concatSolicitud =  this.concatSolicitud.replace(tipo + ", ", "")
      }

  }
 

  /* -------------------------------------------------------------------------- */
  /*                                  CHECK 2D                                  */
  /* -------------------------------------------------------------------------- */
  cambiaItem2(tipo){

      if(this.dosD){

          this.concatSolicitud += tipo + ", ";

      }else{

          this.concatSolicitud =  this.concatSolicitud.replace(tipo + ", ", "")
      }

  }


  /* -------------------------------------------------------------------------- */
  /*                                  CHEK APP                                  */
  /* -------------------------------------------------------------------------- */
  cambiaItem3(tipo){

      if(this.app){

        this.concatSolicitud += tipo + ", ";

      }else{


          this.concatSolicitud =  this.concatSolicitud.replace(tipo + ", ", "")
       
      }

  }


  /* -------------------------------------------------------------------------- */
  /*                       GUARDAR SOLICITUD CAPACITACION                       */
  /* -------------------------------------------------------------------------- */
  guardarSolicitudCap(){
    this.guardarPac = true;
    this.spinnerBooleanBuscarData = true;
    this.doctoresService.guardarRequerimientoCapacitacion(
      this.nuevoComentarioCapacitar,
      this.codigoDoctor,
      this.nuevaFechaCapacitar,
      this.concatSolicitud.substring(0, this.concatSolicitud.length - 2),
      localStorage.getItem('token'),
    ).subscribe((resp) => {
  
      this.spinnerBooleanBuscarData = false;

        if(resp == "ok"){

          this.modalService.dismissAll();
          this.guardarPac = false;
          this.toastr.success("Solicitud de capacitación generada correctamente", 'Atención', {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          });

        }else{
          this.guardarPac = false;
          this.toastr.error(resp, 'Atención', {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          });
        }

    });

  }


  /* -------------------------------------------------------------------------- */
  /*                          CONSULTAR ESPECIALIDADES                          */
  /* -------------------------------------------------------------------------- */
  mostrarEspecialidades(){

    this.especialidadesService.mostrarEspecialidades(localStorage.getItem('token'),null,null).subscribe((resp) => {
      if (this.hasApiError(resp)) {
        this.especialidadesOrdenlist = [];
        this.showApiError(resp, 'No se pudieron cargar especialidades.');
        return;
      }
           
      this.especialidadesOrdenlist = [];
    
        resp.rows.forEach((currentValue, index) => {

      

          this.especialidadesOrdenlist.push({

            "datos": currentValue.NOM_ESP,
            "codigo": currentValue.NOM_ESP
          });


         

        });

      
      
     

    }, (err) => {
      this.especialidadesOrdenlist = [];
    })
  }


  /* -------------------------------------------------------------------------- */
  /*                              ESCOGER SERVICIOS                             */
  /* -------------------------------------------------------------------------- */
  modalEscogerServicio(basicModal:any, tipo, ){
    this.setPage({ offset: 0 });
   this.buscarServicio = "";

   this.totalSeleccionado = 0;

    if(this.tipo!="TOMOGRAFIA 3D (MATRIZ)" && this.tipo!="ECOGRAFIA (MATRIZ - ALBORADA - PORTETE)" && this.tipo!="TOMOGRAFIA 3D (MATRIZ)"){

      this.tipo = tipo;
      this.busquedaOrdenN(this.buscarServicio);
    }else{
      this.tipo = tipo.split(" (")[0];
      this.busquedaOrdenN(this.buscarServicio);

    } 
  
 
    this.modalService.open(basicModal,{
      backdrop: 'static',
      size: 'lg',
      windowClass: 'modal-mobile-full'
    });

    
  }


  /* -------------------------------------------------------------------------- */
  /*                             ABRIR MODAL PIEZAS                             */
  /* -------------------------------------------------------------------------- */
  abrirModalPiezas(basicModal:any,modalListaAnalisis:any, servicio,nombre, id,tipo,precios, impuesto, incluidoIva,listadoAnalisis){
    
    this.servicioEscodigo = nombre;
    let preciosSelect :any[] = [];


    if(servicio=="PERIAP-PLUS" ||servicio=="PERIAPICAL" ){

      this.checkMAbierto = false;
      this.checkMCerrado = false;  
      this.checkMAbierto = false;
      this.checkMCerrado = false;
      
      this.checkMConductometria = true;  
      this.checkMSuperior = false;
      this.checkMInferior= false;
    }

    if(servicio=="40*80-ATM" || servicio=="100*80-SEN PARN" ){

      if(servicio=="40*80-ATM"){

        this.checkMConductometria = false;
        this.checkMAbierto = true;
        this.checkMCerrado = true;  
        this.checkMIzquierda = true;
        this.checkMDerecha = true;
  
        this.checkMSuperior = false;
        this.checkMInferior= false;

      }else{

        this.checkMConductometria = false;
        this.checkMAbierto = false;
        this.checkMCerrado = false;  
        this.checkMIzquierda = true;
        this.checkMDerecha = true;
  
        this.checkMSuperior = false;
        this.checkMInferior= false;
      }

   
    }

 
    if(servicio=="A.T.M." || servicio=="40*80-ATM" || servicio=="40*80-POST ATM" ){


      if(servicio=="40*80-ATM" ){

        this.checkMConductometria = false;
        this.checkMAbierto = true;
        this.checkMCerrado = true;  
        this.checkMSuperior = false;
        this.checkMInferior= false;
        this.checkMIzquierda = true;
        this.checkMDerecha = true;
      }else{

        this.checkMConductometria = false;
        this.checkMAbierto = true;
        this.checkMCerrado = true;  
        this.checkMSuperior = false;
        this.checkMInferior= false;
        this.checkMIzquierda = false;
        this.checkMDerecha = false;
      }

   

    
    }


    
    if(servicio=="100*40-3MOLAR" 
    || servicio=="100*40-DRETEND"
    || servicio=="100*40-PATOLOG"
    || servicio=="100*40-IMPL"
    || servicio=="100*40-ODONTOP"
    || servicio=="100*40-PERIODON"
    || servicio=="100*40-RHB ORAL"
    || servicio=="100*40-ENDODONC"
    || servicio=="100*40 POST TRA-DRETEND"
    || servicio=="100*40 POST TRA-IMPL" 
    || servicio=="100*40 POST TRA-ENDODONC"
    || servicio=="100*40 POST TRA-PATOLOG" 
    || servicio=="OCLU 3D"){
                 
      this.checkMConductometria = false;
      this.checkMAbierto = false;
      this.checkMCerrado = false;  
      this.checkMIzquierda = false;
      this.checkMDerecha = false;
      this.checkMSuperior = true;
      this.checkMInferior= true;
        

  
  }

    
      this.servicioDetalle = servicio;
      this.nombreDetalle = nombre;
      this.idDetalle = id;
      this.precio1Detalle = precios.split(",")[0];
      this.precio2Detalle =  precios.split(",")[1];
      this.precio3Detalle = precios.split(",")[2];
      this.precio4Detalle = precios.split(",")[3];
      this.impuesto = impuesto;
      this.incluidoIva = incluidoIva;
      


    if(servicio !="PANO PLUS" && servicio!="PANO 001" &&  servicio!!="PANO 002" && servicio!="LATE 001" && servicio!="SENOS 001" 
    &&  servicio!="RX-CARPAL" && servicio!="SERIE 002" &&  servicio!="ANTEROPOSTERIOR"  &&  servicio!="ANTEROPOSTERIOR" &&  tipo!="ANTEROPOSTERIOR"){

      
      if(tipo == "RADIOGRAFIA 2D" || tipo == "TOMOGRAFIA 3D (MATRIZ)" || tipo == "TOMOGRAFIA 3D"){

        this.toastr.info("Seleccione unos de los items y presiona aceptar.", 'Atención', {
          timeOut: 4000,
          closeButton: true,
          progressBar: true
        });

        if(tipo == "RADIOGRAFIA 2D" && servicio == "ANALISIS CEFA"){

          this._listadoAnalisis = JSON.parse(listadoAnalisis) || [];
          
          this.modalService.open(modalListaAnalisis,{
                backdrop: 'static',
                size: 'xl',
                
          });
        }else{
          this.modalService.open(basicModal,{
            backdrop: 'static',
            size: 'xl',
            windowClass: 'modal-mobile-full'
          });
        }
   
      }else{
        preciosSelect.push({

            "precio" :  this.precio1Detalle,
            "porcentaje" : "",


            },{

              "precio" :  this.precio2Detalle,
              "porcentaje" : "PRECIO B: ",


          },{

              "precio" :  this.precio3Detalle,
              "porcentaje" : "PRECIO C: ",


          },{

            "precio" :  this.precio4Detalle,
            "porcentaje" : "PRECIO EST: ",


          });

        this.detalleOrden.push({

          id: this.idDetalle,
          producto: this.nombreDetalle,
          codigo : this.servicioDetalle,
          valor: this.precio1Detalle,
          pieza:  this.cadenaPiezas == "" ? "Ninguna" : this.cadenaPiezas,
          agregado: " ",
          precio1: this.precio1Detalle,
          precio2: this.precio2Detalle,
          precio3: this.precio3Detalle,
          precio4: this.precio4Detalle,
          impuesto: this.impuesto,
          incluidoIva: this.incluidoIva,
          precioSeleccionado:  this.precio1Detalle,
          tipo:tipo,
          preciosSelect: preciosSelect,
          reserved: true
          
        });
        this.validarServicioLaboratorioNoFacturado(this.idDetalle, tipo);



        if(tipo !== "LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)"){

          //this.modalService.dismissAll();
        }
       
        this.toastr.success("Servicio aagregado correctamente a la orden", 'Atención', {
          timeOut: 4000,
          closeButton: true,
          progressBar: true
        });
        this.cadenaAB ="";
        this.cadenaConduct = "";
        this.cadenaIZ = "";
        this.cadenaPiezas = "";
        this.cadenaSI ="";
        this.sumarTotalPrecios();
      }

     

    }else{

   
      preciosSelect.push({

        "precio" :  this.precio1Detalle,
        "porcentaje" : "",


        },{

          "precio" :  this.precio2Detalle,
          "porcentaje" : "PRECIO B: ",


      },{

          "precio" :  this.precio3Detalle,
          "porcentaje" : "PRECIO C: ",


      },{

        "precio" :  this.precio4Detalle,
        "porcentaje" : "PRECIO EST: ",


      });
  
        this.detalleOrden.push({
  
          id: this.idDetalle,
          producto: this.nombreDetalle,
          codigo : this.servicioDetalle,
          valor: this.precio1Detalle,
          pieza:  this.cadenaPiezas == "" ? "Ninguna" : this.cadenaPiezas,
          agregado: " ",
          precio1: this.precio1Detalle,
          precio2: this.precio2Detalle,
          precio3: this.precio3Detalle,
          precio4: this.precio4Detalle,
          impuesto: this.impuesto,
          incluidoIva: this.incluidoIva,
          precioSeleccionado:  this.precio1Detalle,
          tipo: tipo,
          preciosSelect: preciosSelect,
          reserved: true
        });
        this.validarServicioLaboratorioNoFacturado(this.idDetalle, tipo);


   

        this.modalService.dismissAll();
        this.toastr.success("Servicio agregado correctamente a la orden", 'Atención', {
          timeOut: 4000,
          closeButton: true,
          progressBar: true
        });

        this.cadenaAB ="";
        this.cadenaConduct = "";
        this.cadenaIZ = "";
        this.cadenaPiezas = "";
        this.cadenaSI ="";
        this.sumarTotalPrecios();
        
      

     
     
    }

  

  }

  seleccionaAnalisisCefa(event,index,analisis){
    if(event.checked){
      this.analisisSeleccionados.push(analisis);
    }else{
      this.analisisSeleccionados = this.analisisSeleccionados.filter(a => a !== analisis);
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                          CERRAR MODAL ODONTOGRAMA                          */
  /* -------------------------------------------------------------------------- */
  cerrarModalOdontograma(){


    this.checkConductometria = false;
    this.checkIzquierda = false;
    this.checkDerecha = false;
    this.checkAbierto = false;
    this.checkCerrado = false;
    this.checkSuperior = false;
    this.checkInferior = false;
    

    this.modalService.dismissAll();
    this.toastr.info("El procedimiento ha sido cancelado", 'Atención', {
      timeOut: 4000,
      closeButton: true,
      progressBar: true
    });

  }
  /* ------------------------------ SOLO NUMEROS ------------------------------ */
  soloNumerosPunto(e) {
    var key = window.Event ? e.which : e.keyCode
    return (key >= 46 && key <= 57)
  }

  showInfoTarjeta(e) {
    let valor = e.target.value;
    if (valor == 'TARJETA DE DEBITO' || valor == 'TARJETA DE CREDITO') {
      this.mostrarInfoTarjeta = true;
    } else {
      this.mostrarInfoTarjeta = false;
    }
  }

  agregarPagoMultiple(){

    if (this.modalMetodoPago == '') {
      this.toastr.info("Seleccione un metodo de pago", 'Atención', {
        timeOut: 4000,
        closeButton: true,
        progressBar: true
      });
    }

    if (this.modalMetodoPago == 'TARJETA DE DEBITO' || this.modalMetodoPago == 'TARJETA DE CREDITO') {
      if (this.modalTipoTarjeta == '') {

        this.toastr.info('Seleccione un tipo de tarjeta', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true,
        });
        return
      }
    }

    if(this.modalImportePago == ''){
      this.toastr.info('Ingrese el importe', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true,
      });
      return
    }

  
    if(Number(this.modalImportePago) <= 0){
      this.toastr.info('Ingrese un valor superior a $ 0.00', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true,
      });
    }
    let valorImporte = Number(this.modalImportePago).toFixed(2);
    let impuestoPorItem = 0;
    if(this.modalMetodoPago == 'TARJETA DE DEBITO' || this.modalMetodoPago == 'TARJETA DE CREDITO' ){
      this.impuestoTarjeta +=  (Number(this.modalImportePago) * 0.06);
      impuestoPorItem = (Number(this.modalImportePago) * 0.06);
      valorImporte = ( Number(this.modalImportePago) * 1.06 ).toFixed(2);
    }

    let objPagos = {
      metodoPago: this.modalMetodoPago,
      tipoTarjeta: this.modalTipoTarjeta,
      importe: valorImporte,
      impuesto: impuestoPorItem
    };

    this.arrayPagos = [...this.arrayPagos, objPagos ];
    //reinicio de los valores
    this.modalMetodoPago = '';
    this.modalTipoTarjeta = '';
    this.modalImportePago = '';

    this.sumarTotalPrecios();
    this.sumarTotalPagosMultiples();
    

  }



  deletePago(index) {
    let impuestoQuitar = this.arrayPagos[index].impuesto;

    if (this.arrayPagos.length > 0) {
      this.arrayPagos.splice(index, 1);
    }
    //RESTABLECE EL VALOR DEL IMPUESTO
    this.impuestoTarjeta -=  Number(impuestoQuitar);
    this.sumarTotalPrecios();

    this.sumarTotalPagosMultiples();
    
    if (this.arrayPagos.length == 0) {
      this.limpiarCamposPagos();
    }
  }

  
  limpiarCamposPagos() {
    this.modalImportePago = "";
    this.modalTipoTarjeta = "";
    this.modalMetodoPago = "";
  }

  sumarTotalPagosMultiples(){
    this.valorCancelado = this.totalPagosRealizados();
    this.valorPendiente = (Number(this.total) - Number(this.valorCancelado)).toFixed(2);
  }

  totalPagosRealizados() {
    let total = this.arrayPagos.reduce((total, pago) => total += parseFloat(pago.importe), 0).toFixed(2);
    return total;
  }

  /* -------------------------------------------------------------------------- */
  /*                           CONCATENA NUMERO PIEZAS                          */
  /* -------------------------------------------------------------------------- */
  getNumeroPiezas(event){

     if(event.target.checked){

      this.cadenaPiezas += event.target.value+", ";

     }else{

       this.cadenaPiezas = this.cadenaPiezas.replace(event.target.value+", ", "");
     }

   
   
  }


  /* -------------------------------------------------------------------------- */
  /*                            MARCAR CONDUCTOMETRÍA                           */
  /* -------------------------------------------------------------------------- */
  cbxConductometria(){

      if(this.checkConductometria){


        this.cadenaConduct = "Conductometría, ";

      }else{

         this.cadenaConduct = this.cadenaConduct.replace("Conductometría, " , "");
      }

    
  }


  /* -------------------------------------------------------------------------- */
  /*                            CHECK PARTE IZQUIERDA                           */
  /* -------------------------------------------------------------------------- */
  cbxIzquierda(){

    if(this.checkIzquierda){

      this.checkDerecha = false;

      this.cadenaIZ = "Izquierda, ";
      this.cadenaIZ = this.cadenaIZ.replace("Derecha, " , "");

    }else{

       this.cadenaIZ = this.cadenaIZ.replace("Izquierda, " , "");
    }


  }


  /* -------------------------------------------------------------------------- */
  /*                             CHECK PARTE DERECHA                            */
  /* -------------------------------------------------------------------------- */
  cbxDerecha(){

    if(this.checkDerecha){

      this.checkIzquierda = false;

      this.cadenaIZ = "Derecha, ";
      this.cadenaIZ = this.cadenaIZ.replace("Izquierda, " , "");

    }else{

      this.cadenaIZ = this.cadenaIZ.replace("Derecha, " , "");
    }

   
  }


  /* -------------------------------------------------------------------------- */
  /*                             CHECK PARTE ABIERTO                            */
  /* -------------------------------------------------------------------------- */
  cbxAbierto(){

    if(this.checkAbierto){

      this.checkCerrado = false;

      this.cadenaAB = "Abierto, ";
      this.cadenaAB = this.cadenaAB.replace("Cerrado, " , "");

    }else{

       this.cadenaAB = this.cadenaAB.replace("Abierto, " , "");
    }

  
  }


  /* -------------------------------------------------------------------------- */
  /*                             CHECK PARTE CERRADO                            */
  /* -------------------------------------------------------------------------- */
  cbxCerrado(){

    if(this.checkCerrado){

      this.checkAbierto = false;

      this.cadenaAB = "Cerrado, ";
      this.cadenaAB = this.cadenaAB.replace("Abierto, " , "");

    }else{

      this.cadenaAB = this.cadenaAB.replace("Cerrado, " , "");
    }

   
  }


  /* -------------------------------------------------------------------------- */
  /*                            CHECK PARTE SUPERIOR                            */
  /* -------------------------------------------------------------------------- */
  cbxSuperior(){

    if(this.checkSuperior){

      this.checkInferior = false;

      this.cadenaSI = "Superior, ";
      this.cadenaSI = this.cadenaSI.replace("Inferior, " , "");

    }else{

       this.cadenaSI = this.cadenaSI.replace("Superior, " , "");
    }


  }


  /* -------------------------------------------------------------------------- */
  /*                            CHECK PARTE INFERIOR                            */
  /* -------------------------------------------------------------------------- */
  cbxInferior(){

    if(this.checkInferior){

      this.checkSuperior = false;

      this.cadenaSI = "Inferior, ";
      this.cadenaSI = this.cadenaSI.replace("Superior, " , "");

    }else{

      this.cadenaSI = this.cadenaSI.replace("Inferior, " , "");
    }

    
  }


  /* -------------------------------------------------------------------------- */
  /*                         AGREGAR DETALLE A LA ORDEN                         */
  /* -------------------------------------------------------------------------- */
  agregarDetalleMDOdont(){
    let preciosSelect :any[] = [];
    this.checkConductometria = false;
    this.checkIzquierda = false;
    this.checkDerecha = false;
    this.checkAbierto = false;
    this.checkCerrado = false;
    this.checkSuperior = false;
    this.checkInferior = false;
    

    this.cadenaPiezas+= this.cadenaConduct+this.cadenaAB+this.cadenaIZ+this.cadenaSI;

    preciosSelect.push({

      "precio" :  this.precio1Detalle,


      },{

        "precio" :  this.precio2Detalle,


    },{

        "precio" :  this.precio3Detalle,


    },{

      "precio" :  this.precio4Detalle,


    });

    this.detalleOrden.push({

      id: this.idDetalle,
      producto: this.nombreDetalle,
      codigo : this.servicioDetalle,
      valor: this.precio1Detalle,
      pieza:  this.cadenaPiezas == "" ? "Ninguna" : "Número de piezas: "+ this.cadenaPiezas.substring(0,  this.cadenaPiezas.length - 2),
      agregado: " ",
      precio1: this.precio1Detalle,
      precio2: this.precio2Detalle,
      precio3: this.precio3Detalle,
      precio4: this.precio4Detalle,
      impuesto: this.impuesto,
      incluidoIva: this.incluidoIva,
      precioSeleccionado: this.precio1Detalle,
      tipo: this.tipo,
      preciosSelect: preciosSelect,
      reserved: true
    });


    this.modalService.dismissAll();
    this.toastr.success("Servicio aagregado correctamente a la orden", 'Atención', {
      timeOut: 4000,
      closeButton: true,
      progressBar: true
    });
    this.cadenaAB ="";
    this.cadenaConduct = "";
    this.cadenaIZ = "";
    this.cadenaPiezas = "";
    this.cadenaSI ="";
    this.sumarTotalPrecios();

  }

  agregarDetalleAnalisisCefa(){
    
    let preciosSelect :any[] = [];
    preciosSelect.push({

      "precio" :  this.precio1Detalle,


      },{

        "precio" :  this.precio2Detalle,


    },{

        "precio" :  this.precio3Detalle,


    },{

      "precio" :  this.precio4Detalle,


    });

    this.detalleOrden.push({
      id: this.idDetalle,
      producto: this.nombreDetalle,
      codigo : this.servicioDetalle,
      valor: this.precio1Detalle,
      pieza:  "Analisis: " + this.analisisSeleccionados.join(", "),
      agregado: " ",
      precio1: this.precio1Detalle,
      precio2: this.precio2Detalle,
      precio3: this.precio3Detalle,
      precio4: this.precio4Detalle,
      impuesto: this.impuesto,
      incluidoIva: this.incluidoIva,
      precioSeleccionado: this.precio1Detalle,
      tipo: this.tipo,
      preciosSelect: preciosSelect,
      reserved: true
    });


    this.modalService.dismissAll();
    this.toastr.success("Servicio agregado correctamente a la orden", 'Atención', {
      timeOut: 4000,
      closeButton: true,
      progressBar: true
    });
    this.esAnalisiCefa = "Si";
    this.analisisSeleccionados = [];
    this.sumarTotalPrecios();
  }
  /* -------------------------------------------------------------------------- */
  /*                                 PRECIO ITEM                                */
  /* -------------------------------------------------------------------------- */
  precioItem(codigo,precio1:any, precio2, precio3, precio4, derivado, tipo, precioLab, preciosDerivados){

    if(precioLab!="" && tipo=="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)"){

      if(precioLab=="A"){

        precio1 = precio1;
       
      }

      if(precioLab=="B"){

        precio1 =  precio2 == ""  ? precio1 : precio2;

      
      }

      if(precioLab=="C"){

        precio1 = precio3 == ""  ? precio1 :precio3 ;
      
      }
      if(precioLab=="D"){

       precio1 = precio4  == ""  ? precio1 : precio4 ;
       
      }


  }else{

  
    if(precio1==""){
      
      precio1 = this.talonarioDocotor;
  
      
    }

  }

  var precioDerivado = "";
  
  if(derivado=="1"){

    var content = JSON.parse(preciosDerivados);
    $.each(content, function(id, name) {


      precioDerivado = name.precio;


  });
      
  }
  
 
  if(Number(precio2)<Number(precioDerivado)){
      
      precio2 = "";
  }
  
  if(Number(precio3)<Number(precioDerivado)){
      
      precio3 = "";
  }
  
    if(Number(precio4)<Number(precioDerivado)){
      
      precio4 = "";
  }


  if(this.metodosPagos!="EFECTIVO" && this.metodosPagos!=""&& this.metodosPagos!="TRANSFERENCIA" && this.metodosPagos!="PAGO MULTIPLE" && this.metodosPagos!="CREDITO"){
                
   
    precio1 = (precio1*1.06);
    precio1 = parseFloat(precio1).toFixed(2)

    precio2 = (precio2 == "" ? 0 : precio2 *1.06);
    precio2 = parseFloat(precio2).toFixed(2)

    precio3 = (precio3 == "" ? 0 : precio3*1.06);
    precio3 = parseFloat(precio3).toFixed(2)

    precio4 = (precio4 == "" ? 0 : precio4 *1.06);
    precio4 = parseFloat(precio4).toFixed(2)
  
  
  }
   


    return precio1+","+precio2+","+precio3+","+precio4;
  }


  /* -------------------------------------------------------------------------- */
  /*                             BUSCAR DIMENSIONES                             */
  /* -------------------------------------------------------------------------- */
  buscarDimensiones1(){

    if(this.dime1){

      this.dime2 = false;
      this.dime3 = false;
      this.dime4 = false;
      this.dime5 = false;
      this.dime6 = false;

      this.buscarServicio = "100*80";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "100*80";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)
    }else{

      this.dime2 = false;
      this.dime3 = false;
      this.dime4 = false;
      this.dime5 = false;
      this.dime6 = false;
      this.buscarServicio = "";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "100*80";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)

    }


  }


  /* -------------------------------------------------------------------------- */
  /*                            BUSCAR DIMENSIONES 2                            */
  /* -------------------------------------------------------------------------- */
  buscarDimensiones2(){

  if(this.dime2){

    this.dime1 = false;
    this.dime3 = false;
    this.dime4 = false;
    this.dime5 = false;
    this.dime6 = false;
    this.buscarServicio = "100*40";
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      let busqued = "vacio";
    this.pageNumber = 0;
    if (this.buscarServicio != "") {

      busqued =  "100*40";
    }

    this.busquedaOrdenN(busqued);
      clearTimeout(this.timeout)
    },1000)
  }else{

    this.dime1 = false;
    this.dime3 = false;
    this.dime4 = false;
    this.dime5 = false;
    this.dime6 = false;
    this.buscarServicio = "";
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      let busqued = "vacio";
    this.pageNumber = 0;
    if (this.buscarServicio != "") {

      busqued =  "100*40";
    }

    this.busquedaOrdenN(busqued);
      clearTimeout(this.timeout)
    },1000)

  }

  }


  /* -------------------------------------------------------------------------- */
  /*                            BUSCAR DIMENSIONES 3                            */
  /* -------------------------------------------------------------------------- */
  buscarDimensiones3(){

    if(this.dime3){

      this.dime2 = false;
      this.dime1 = false;
      this.dime4 = false;
      this.dime5 = false;
      this.dime6 = false;
      this.buscarServicio = "40*80";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "40*80";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)
    }else{

      this.dime2 = false;
      this.dime1 = false;
      this.dime4 = false;
      this.dime5 = false;
      this.dime6 = false;
      this.buscarServicio = "";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "40*80";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)

    }

  }


  /* -------------------------------------------------------------------------- */
  /*                            BUSCAR DIMENSIONES 4                            */
  /* -------------------------------------------------------------------------- */
  buscarDimensiones4(){

    if(this.dime4){

      this.dime2 = false;
      this.dime3 = false;
      this.dime1 = false;
      this.dime5 = false;
      this.dime6 = false;
      this.buscarServicio = "40*40";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "40*40";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)
    }else{

      this.dime2 = false;
      this.dime3 = false;
      this.dime1 = false;
      this.dime5 = false;
      this.dime6 = false;
      this.buscarServicio = "";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "40*40";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)

    }

  }


  buscarDimensiones5(){

    if(this.dime5){

      this.dime2 = false;
      this.dime3 = false;
      this.dime1 = false;
      this.dime4 = false;
      this.dime6 = false;

      this.buscarServicio = "210*160";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "210*160";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)
    }else{

      this.dime2 = false;
      this.dime3 = false;
      this.dime1 = false;
      this.dime4 = false;
      this.dime6 = false;
      this.buscarServicio = "";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "210*160";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)

    }

  }

  buscarDimensiones6(){

    if(this.dime6){

      this.dime2 = false;
      this.dime3 = false;
      this.dime1 = false;
      this.dime4 = false;
      this.dime5 = false;

      this.buscarServicio = "150*160";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "150*160";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)
    }else{

      this.dime2 = false;
      this.dime3 = false;
      this.dime1 = false;
      this.dime4 = false;
      this.dime5 = false;

      this.buscarServicio = "";
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        let busqued = "vacio";
      this.pageNumber = 0;
      if (this.buscarServicio != "") {
  
        busqued =  "150*160";
      }
  
      this.busquedaOrdenN(busqued);
        clearTimeout(this.timeout)
      },1000)

    }

  }

  /* -------------------------------------------------------------------------- */
  /*                              OBTENER PERFILES                              */
  /* -------------------------------------------------------------------------- */
  obtenerPerfiles(){

    this.listaPerfiles = [];
    this.serviciosService.mostrarServicios( localStorage.getItem('token'),  null, null, null, null, "obtener-perfiles").subscribe((resp) => {
    
      resp.rows.forEach((currentValue, index) => {

            
        
        
            this.listaPerfiles.push({

            "perfil":  currentValue.PER_TIPMUES,
            "codigo": currentValue.COD_TIPMUES
          });

        

       

      });
     

    });

   


  }

  obtenerServiciosConSubServicios(){

    this.listaSubServicios = [];
    this.serviciosService.mostrarServiciosConSubServicios( localStorage.getItem('token')).subscribe((resp) => {
    
      resp.forEach((currentValue, index) => {


            this.listaSubServicios.push({

            "servicio":  currentValue.NOM_PRO,
            "idServicio": currentValue.COD_PRO
          });
      });
     

    });
  }

  /* -------------------------------------------------------------------------- */
  /*                         OBTENER PORDUCTOS PERFILES                         */
  /* -------------------------------------------------------------------------- */
  buscarPerfil(event, codigo){


    if(event.target.checked){

      this.modalService.dismissAll();
      var preciosSelect :any[] = [];
      Swal.fire({
        icon: 'warning',
        title: '¿Está seguro desea seleccionar todos los servicios de este perfil?',
        text: '¡si no lo está puede cancelar la acción!',
        showCancelButton: true,
        confirmButtonColor: '#0162e8',
        cancelButtonColor: '#FF0000',
        confirmButtonText: 'Si, seleccionar!',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
  
      }).then((result) => {
  
        if (result.isConfirmed) {

          
  

          this.serviciosService.mostrarServicios( localStorage.getItem('token'),  null, null, codigo, null, "obtener-productos-perfiles").subscribe((resp) => {
    
            resp.rows.forEach((currentValue, index) => {
    
              var itemP = this.precioItem(currentValue.CODN_PRO, currentValue.VAL_PRO,currentValue.VAL2_PRO, currentValue.VAL3_PRO, currentValue.VAL4_PRO, currentValue.DER_PRO, currentValue.TIP_PRO, currentValue.preciosLab, currentValue.VALEMP_PRO);
              let preciosSelect :any[] = [];
              let precioSeleccion = currentValue.VALOR_PER != ""  ? currentValue.VALOR_PER :  itemP.split(",")[0];
              preciosSelect.push({
             
                         "precio" :  precioSeleccion,
                         "porcentaje" : "",
             
             
                         },{
             
                           "precio" : itemP.split(",")[1],
                           "porcentaje" : "PRECIO B: ",
             
             
                       },{
             
                           "precio" :  itemP.split(",")[2],
                           "porcentaje" : "PRECIO C: ",
                       },{
             
                         "precio" : itemP.split(",")[3],
                         "porcentaje" : "PRECIO EST: ",
             
             
                       });
             
              this.detalleOrden.push({
    
                id: currentValue.COD_PRO,
                producto: currentValue.NOM_PRO,
                codigo : currentValue.CODN_PRO,
                valor: currentValue.VAL_PRO,
                pieza:  "Ninguna",
                agregado: " ",
                precio1: precioSeleccion,
                precio2: itemP.split(",")[1],
                precio3: itemP.split(",")[2],
                precio4: itemP.split(",")[3],
                impuesto: currentValue.IMP_PRO,
                incluidoIva: currentValue.INCLIVA_PRO,
                precioSeleccionado: precioSeleccion,
                tipo:currentValue.TIP_PRO,
                preciosSelect: preciosSelect,
                reserved: true
              });   
              this.validarServicioLaboratorioNoFacturado(currentValue.COD_PRO, currentValue.TIP_PRO);
    
         
               
            });
    
            this.toastr.success("Servicios aagregado correctamente a la orden", 'Atención', {
              timeOut: 4000,
              closeButton: true,
              progressBar: true
            });
            this.modalService.dismissAll();
            this.cadenaAB ="";
            this.cadenaConduct = "";
            this.cadenaIZ = "";
            this.cadenaPiezas = "";
            this.cadenaSI ="";
            this.sumarTotalPrecios();
          });

        }
  
      
  
      });

  

    }


  

  }


  buscarSubServicios(codigo){

      this.modalService.dismissAll();

      if(Number(codigo) !== 3){


      Swal.fire({
        icon: 'warning',
        title: '¿Está seguro desea seleccionar todos los subservicios de este servicio?',
        text: '¡si no lo está puede cancelar la acción!',
        showCancelButton: true,
        confirmButtonColor: '#0162e8',
        cancelButtonColor: '#FF0000',
        confirmButtonText: 'Si, seleccionar!',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
  
      }).then((result) => {
  
        if (result.isConfirmed) {

          this.serviciosService.mostrarSubServiciosById( localStorage.getItem('token'), codigo).subscribe((resp) => {

            resp.forEach((currentValue, index) => {
    

              var itemP = this.precioItem(currentValue.CODN_PRO, currentValue.VAL_PRO,currentValue.VAL2_PRO, currentValue.VAL3_PRO, currentValue.VAL4_PRO, currentValue.DER_PRO, currentValue.TIP_PRO, currentValue.preciosLab, currentValue.VALEMP_PRO);
              let preciosSelect :any[] = [];
              let precioSeleccion =  itemP.split(",")[0];
              preciosSelect.push({
             
                         "precio" :  precioSeleccion,
                         "porcentaje" : "",
             
             
                         },{
             
                           "precio" : itemP.split(",")[1],
                           "porcentaje" : "PRECIO B: ",
             
             
                       },{
             
                           "precio" :  itemP.split(",")[2],
                           "porcentaje" : "PRECIO C: ",
                       },{
             
                         "precio" : itemP.split(",")[3],
                         "porcentaje" : "PRECIO EST: ",
             
             
                       });
             
              this.detalleOrden.push({
    
                id: currentValue.COD_PRO,
                producto: currentValue.NOM_PRO,
                codigo : currentValue.CODN_PRO,
                valor: currentValue.VAL_PRO,
                pieza:  "Ninguna",
                agregado: " ",
                precio1: precioSeleccion,
                precio2: itemP.split(",")[1],
                precio3: itemP.split(",")[2],
                precio4: itemP.split(",")[3],
                impuesto: currentValue.IMP_PRO,
                incluidoIva: currentValue.INCLIVA_PRO,
                precioSeleccionado: precioSeleccion,
                tipo:currentValue.TIP_PRO,
                preciosSelect: preciosSelect,
                reserved: true
              });   

            });
    
            this.toastr.success("Servicios aagregado correctamente a la orden", 'Atención', {
              timeOut: 4000,
              closeButton: true,
              progressBar: true
            });
            this.modalService.dismissAll();
            this.cadenaAB ="";
            this.cadenaConduct = "";
            this.cadenaIZ = "";
            this.cadenaPiezas = "";
            this.cadenaSI ="";
            this.sumarTotalPrecios();

          })

        }
      })
        
    }else{

      this.serviciosService.mostrarSubServiciosById( localStorage.getItem('token'), codigo).subscribe((resp) => {

        resp.forEach((currentValue, index) => {


          var itemP = this.precioItem(currentValue.CODN_PRO, currentValue.VAL_PRO,currentValue.VAL2_PRO, currentValue.VAL3_PRO, currentValue.VAL4_PRO, currentValue.DER_PRO, currentValue.TIP_PRO, currentValue.preciosLab, currentValue.VALEMP_PRO);
          let preciosSelect :any[] = [];
          let precioSeleccion =  itemP.split(",")[0];
          preciosSelect.push({
         
                     "precio" :  precioSeleccion,
                     "porcentaje" : "",
         
         
                     },{
         
                       "precio" : itemP.split(",")[1],
                       "porcentaje" : "PRECIO B: ",
         
         
                   },{
         
                       "precio" :  itemP.split(",")[2],
                       "porcentaje" : "PRECIO C: ",
                   },{
         
                     "precio" : itemP.split(",")[3],
                     "porcentaje" : "PRECIO EST: ",
         
         
                   });
         
          this.detalleOrden.push({

            id: currentValue.COD_PRO,
            producto: currentValue.NOM_PRO,
            codigo : currentValue.CODN_PRO,
            valor: currentValue.VAL_PRO,
            pieza:  "Ninguna",
            agregado: " ",
            precio1: precioSeleccion,
            precio2: itemP.split(",")[1],
            precio3: itemP.split(",")[2],
            precio4: itemP.split(",")[3],
            impuesto: currentValue.IMP_PRO,
            incluidoIva: currentValue.INCLIVA_PRO,
            precioSeleccionado: precioSeleccion,
            tipo:currentValue.TIP_PRO,
            preciosSelect: preciosSelect,
            reserved: true
          });   
          this.validarServicioLaboratorioNoFacturado(currentValue.COD_PRO, currentValue.TIP_PRO);

        });

        this.toastr.success("Servicios aagregado correctamente a la orden", 'Atención', {
          timeOut: 4000,
          closeButton: true,
          progressBar: true
        });
        this.modalService.dismissAll();
        this.cadenaAB ="";
        this.cadenaConduct = "";
        this.cadenaIZ = "";
        this.cadenaPiezas = "";
        this.cadenaSI ="";
        this.sumarTotalPrecios();

      })

    }

    
  }


  /* -------------------------------------------------------------------------- */
  /*                              CONVERTIR FLOAT>                              */
  /* -------------------------------------------------------------------------- */
  convertirFloat(valor){
  

    return parseFloat(valor).toFixed(2);

  }

  private validarServicioLaboratorioNoFacturado(codPro: any, tipoServicio: any): void {
    const tipo = String(tipoServicio || '').trim().toUpperCase();
    if (tipo !== 'LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)') return;

    const cod = Number(codPro);
    if (!cod) return;
    this.serviciosService.validarFacturacionLaboratorio(localStorage.getItem('token'), cod).subscribe((resp) => {
      const row = Array.isArray(resp?.rows) && resp.rows.length ? resp.rows[0] : null;
      const estadoFacturacion = String(row?.estado_facturacion || '').trim().toUpperCase();
      const sales = Number(row?.sales ?? 0);
      if (estadoFacturacion === 'NO FACTURADO' && sales === 0) {
        const nombreServicio = String(row?.NOM_PRO || this.detalleOrden.find((x) => Number(x.id) === cod)?.producto || '').trim();
        this.modalService.dismissAll();
        Swal.fire({
          icon: 'warning',
          title: 'Servicio no facturado',
          text: `El servicio ${nombreServicio || '(sin nombre)'} no ha sido facturado aún. Por favor consulte con el area de laboratorio.`,
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#0162e8'
        });

        const idx = this.detalleOrden.map((x) => Number(x.id)).lastIndexOf(cod);
        if (idx >= 0) {
          this.detalleOrden.splice(idx, 1);
          this.sumarTotalPrecios();
        }
      }
    });
  }

  
  /* -------------------------------------------------------------------------- */
  /*                             SUMAR TOTAL PRECIOS                            */
  /* -------------------------------------------------------------------------- */
  sumarTotalPrecios(){


    let valorTotalP = 0;
    let valorTotalSP = 0;
    this.detalleOrden.forEach((currentValue, index) => {
      if (!currentValue) {
        return;
      }


      if (currentValue.impuesto == "12") {

        if(currentValue.incluidoIva == "NO"){

          valorTotalP+= Number(currentValue.precioSeleccionado);
        }else{

          valorTotalP += Number(currentValue.precioSeleccionado)/1.12;
        }
      }
      if (currentValue.impuesto == "0") {

        valorTotalSP += Number(currentValue.precioSeleccionado);
      }

     

    });

    let subtotalF = Number(valorTotalP) + Number(valorTotalSP);
    let ivaF = Number(valorTotalP) * 0.12;
    let totalFinal = subtotalF + ivaF

    /* ----------- Asignar valores a la vista formateado 2 decimales ----------- */

    this.subtotalImpuesto = parseFloat(valorTotalP.toString()).toFixed(2);
    this.subtotalSinImpuesto = parseFloat(valorTotalSP.toString()).toFixed(2);
    this.subtotal = Number(subtotalF + this.impuestoTarjeta).toFixed(2);
    this.iva = parseFloat(ivaF.toString()).toFixed(2);
    this.total = Number(totalFinal + this.impuestoTarjeta).toFixed(2);
  }

  /* -------------------------------------------------------------------------- */
  /*                                ELIMINAR ITEM                               */
  /* -------------------------------------------------------------------------- */
  deleteRow(index) {

    if (this.detalleOrden.length <= 0) {


      this.subtotalImpuesto= parseFloat('0').toFixed(2);
      this.subtotalSinImpuesto = parseFloat('0').toFixed(2);
      this.subtotal = parseFloat('0').toFixed(2);
      this.iva = parseFloat('0').toFixed(2);
      this.total = parseFloat('0').toFixed(2);

     

     
    } else {

  

    

      

        this.detalleOrden.splice(index, 1);

        this.toastr.success('Fila eliminada correctamente', 'Fila eliminada',
          {
            timeOut: 1000,
            closeButton: true,
            progressBar: true,
            positionClass: "toast-bottom-right",
          });


        this.sumarTotalPrecios();
        this.sumarTotalPagosMultiples();



      }

     

    
  }

  /* -------------------------------------------------------------------------- */
  /*                           SOLICITUD CAMBIO PRECIO                          */
  /* -------------------------------------------------------------------------- */
  solicitudCambio(event,basicModal:any, index, id, nombre, codigo, precio1, precio2, precio3, precio4, tipo){

    if(event.target.checked){
        this.tipoMensaje = "individual";
        this.productoSeleccionadoCP = nombre;
        this.preciosCambioList = [];
        this.cbxPrecioSugerido = false;
        this.txtPreciosDisponibles = "";
        this.precioSugerido = "PRECIO SUGERIDO"
        this.txtPrecioSugerido = "";
        this.contenedorValidarPrecio = false;
        this.codigoFacturadorValidacion= "";
        this.solicitudPrecioActualId = "";
        this.solicitudPrecioResultado = null;
        this.codigosAprobadosHoy = [];
        this.preciosCambioList.push({
    
          item: "Seleccione...",
          valor: ""
        },{
      
    
          item: "PRECIO B:  "+ parseFloat(precio2).toFixed(2),
          valor: parseFloat(precio2).toFixed(2)
        },{
    
          item: "PRECIO ESTUDIANTE: "+parseFloat(precio3).toFixed(2),
          valor: parseFloat(precio3).toFixed(2)
        },
        {
    
          item: "PRECIO DOCTOR: "+parseFloat(precio4).toFixed(2),
          valor: parseFloat(precio4).toFixed(2)
        })
    
        this.modalService.open(basicModal,{
          backdrop: 'static'
        });

        this.precioNormalSolicitad = precio1;
        this.nombreServicioSolicitado = nombre;
        this.tipoSolicitud = tipo;
        if(this.tipoSolicitud=="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)" || this.tipoSolicitud=="LABORATORIO"){

          this.cbxPrecioSugerido = true;
          this.txtPreciosDisponibles = "";
          this.precioSugerido = "PORCENTAJE SUGERIDO"
        }
        this.index = index;
        this.actualizarCodigosAprobadosHoy(false);

    }

 
  }


  /* -------------------------------------------------------------------------- */
  /*                            CHECK PRECIO SUGERIDO                           */
  /* -------------------------------------------------------------------------- */
  changePrecios(event){

    if(event.target.checked){

      this.cbxPrecioSugerido = true;
      this.cbxCuponDescuento = false;
      this.txtPreciosDisponibles = "";

    }else{
      this.cbxPrecioSugerido = false;
      this.txtPreciosDisponibles = "";

    }
  }
  cbxchangePreciosCupon(event){

    if(event.target.checked){

      this.cbxCuponDescuento = true;
      this.cbxPrecioSugerido = false;
      this.txtPreciosDisponibles = "";

    }else{
      this.cbxCuponDescuento = false;
      this.txtPreciosDisponibles = "";

    }

     console.log(this.cbxCuponDescuento);
  }

  /* -------------------------------------------------------------------------- */
  /*                              SOLCITIAR PRECIO                              */
  /* -------------------------------------------------------------------------- */
  solicitarCambio(){
    

    var codigoR = Math.floor(Math.random() * 10000000000);
    var codigoBase = "";
    this.spinnerBoolean = true;
    var precioFinal = "";
    this.solicitudPrecioResultado = null;
        this.codigosAprobadosHoy = [];
    
    this.ordenesService.encriptarCodigo(localStorage.getItem('token'),codigoR).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp));
 
      codigoBase  = content[0].BASE;


       if(this.cbxPrecioSugerido){

        precioFinal = this.txtPrecioSugerido;
       }else{

        precioFinal = this.txtPreciosDisponibles;
       }

       if(precioFinal.length == 0 || Number(precioFinal) < 0){
        this.toastr.info("Ingrese o seleccione un precio...", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
        this.spinnerBoolean = false;
        return;

       }
      
      
   
      this.ordenesService.solicitarCambioPrecio(
        this.nombreUsuario,
        this.idUsuario,
        precioFinal,
        this.nombreServicioSolicitado,
        this.precioNormalSolicitad,
        this.nombreSucursal, 
        this.idSucursal,
        this.tipoSolicitud !="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)" && this.tipo!="LABORATORIO" ? "normal" : "laboratorio",
        this.precioNormalSolicitad,
        this.tipoMensaje,
        this.detalleOrden.length,
        this.nombreDoctor ,
        localStorage.getItem('token'),
      
      ).subscribe((resp) => {

        var content = JSON.parse(JSON.stringify(resp));
  
        if(content.status){
          this.spinnerBoolean = false;
          this.contenedorValidarPrecio = true;
          this.solicitudPrecioActualId = String(content.id || "");
          this.solicitudesPreciosAdministracionService.iniciarSeguimientoSolicitud(this.solicitudPrecioActualId, this.idUsuario, this.idSucursal);
          this.actualizarCodigosAprobadosHoy(false);
          this.codigoValidacion = content.rand; 
        
        }else{
          this.spinnerBoolean = false;
          const mensaje = content?.message || content || 'No fue posible crear la solicitud de cambio de precio';

          this.toastr.error(mensaje, 'Atención', {
            timeOut: 9000,
            closeButton: true,
            progressBar: true
          });
            
        }
  
      });
      
  
     }, (err) => {
       console.warn('request_error_suppressed', err);
     })
     
 


  }


  /* -------------------------------------------------------------------------- */
  /*                               VALIDAR CODIGO                               */
  /* -------------------------------------------------------------------------- */
  private obtenerCodigoSolicitudPrecio(): string {
    const codigoIngresado = String(this.codigoFacturadorValidacion ?? '').trim();
    if (codigoIngresado) {
      return codigoIngresado;
    }

    const codigoAprobado = String(this.solicitudPrecioResultado?.codigo ?? '').trim();
    if (codigoAprobado) {
      this.codigoFacturadorValidacion = codigoAprobado;
      return codigoAprobado;
    }

    return '';
  }

  private mostrarCodigoSolicitudNoDisponible(): void {
    this.toastr.info('Espere la aprobación de administración para recibir el código de verificación.', 'Atención', {
      timeOut: 6000,
      closeButton: true,
      progressBar: true
    });
  }

  validarCodigo(){
    const codigoSolicitudPrecio = this.obtenerCodigoSolicitudPrecio();
    if (!codigoSolicitudPrecio) {
      this.mostrarCodigoSolicitudNoDisponible();
      return;
    }

    this.ordenesService.encriptarCodigo(localStorage.getItem('token'), codigoSolicitudPrecio).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp));

     
 
      this.codigoFacturadorValidacion  = content[0].BASE;
      if(this.codigoFacturadorValidacion == this.codigoValidacion){

        this.toastr.success("Código validado correctamente", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
        var precioFinal  = 0;
        if(this.cbxPrecioSugerido){

          if(this.tipoSolicitud =="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)" || this.tipoSolicitud =="LABORATORIO"){

             precioFinal =Number(this.precioNormalSolicitad) - (Number(this.precioNormalSolicitad) * Number(this.txtPrecioSugerido)/100);
            //precioFinal = parseFloat(precioFinal).toFixed(2);
          }else{

             precioFinal = Number(this.txtPrecioSugerido);
          }
          this.detalleOrden[this.index].preciosSelect.push({

            "precio" : precioFinal,
            "porcentaje" : this.precioNormalSolicitad
            
          })
          this.detalleOrden[this.index].precioSeleccionado  = parseFloat(precioFinal.toString()).toFixed(2);

        }else{

            this.detalleOrden[this.index].precioSeleccionado  = this.txtPreciosDisponibles;
        }

    
        this.modalService.dismissAll();
        this.sumarTotalPrecios();

        
      
      }else{

        this.toastr.error("Código invalido", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

private normalizeType(t: any): string {
  return (t ?? '').toString().trim().toUpperCase();
}
private existeMezclaBazar(): boolean {
  // normaliza tipos, quita vacíos
  const tipos = this.detalleOrden
    .map(d => this.normalizeType(d.tipo))
    .filter(t => t.length > 0);

  // considera como BAZAR cualquier variante que empiece con "BAZAR"
  const isBazar = (t: string) => t.startsWith('BAZAR');

  const hasBazar    = tipos.some(isBazar);
  const hasNonBazar = tipos.some(t => !isBazar(t));

  // hay mezcla solo si coexisten ambos
  return hasBazar && hasNonBazar;
}
  /* -------------------------------------------------------------------------- */
  /*              ABRIR MODAL PARA DAR CAMBIO Y GUARDAR TRANSACCION             */
  /* -------------------------------------------------------------------------- */
  modalGuardarTransaccion(basicModal:any){
    
    this.removeLaboratorioDuplicates();
    this.sumarTotalPrecios();

  if (this.existeMezclaBazar()) {
    this.toastr.error(
      'No se puede mezclar productos BAZAR con otros tipos en la misma factura. Verifique.',
      'Atención',
      { timeOut: 5000, closeButton: true, progressBar: true }
    );
    Swal.fire({
      icon: 'info',
      title: 'Atención',
      text: '¡No se puede mezclar productos de BAZAR con servicios en la misma orden, verificar!',
      confirmButtonText: 'Aceptar!',
      reverseButtons: true
    });
    return;
  }


   this.spinnerBoolean =false;


    if( (this.nombre == "CONSUMIDOR FINAL" || this.nombreAdicional == "CONSUMIDOR FINAL") && parseFloat(this.total) >= 50 ){
      this.toastr.error('El total de la venta supera el monto de 50 dolares, permitidos para consumidor final', 'Atención', {
        timeOut: 4000,
        closeButton: true,
        progressBar: true
      });
        
      return;
    }


    if(this.idPaciente==""){
      this.toastr.error('Seleccione un paciente.', 'Atención', {
        timeOut: 4000,
        closeButton: true,
        progressBar: true
      });
        
      return;
    }

    if(this.codigoDoctor==""){
      this.toastr.error('Seleccione un doctor.', 'Atención', {
        timeOut: 4000,
        closeButton: true,
        progressBar: true
      });
        
      return;
    }

    if(this.telefono.indexOf("+593")>-1){

        if(this.telefono.length!=13){
          this.toastr.error('El formato de celular para el País de Ecuador no es correcto por favor revise y vuelva intentar.', 'Atención', {
            timeOut: 4000,
            closeButton: true,
            progressBar: true
          });
            
          return;
            
        }
    }

    if(this.nuevoTelefonoEnCardP.trim().length<10 && this.mTelefonoDoctor){

     
        this.toastr.error('El télefono que desea cambiar del paciente debe contener 10 digitos si desea modificar un teléfono para otro país precione el boton editar en sección paciente.', 'Atención', {
          timeOut: 7000,
          closeButton: true,
          progressBar: true
        });
          
        return;
          
      
    }
    if(this.nuevoTelefonoEnCardD.length<10 && this.editarTelefonoDoctor){

     
      this.toastr.error('El télefono que desea cambiar del doctor debe contener 10 digitos.', 'Atención', {
        timeOut: 7000,
        closeButton: true,
        progressBar: true
      });
        
      return;
        
    
  }

  if( this.metodoPagoV == 'PAGO MULTIPLE' ){
    this.sumarTotalPagosMultiples();


      this.modalService.open(this.modalMultiplesPagos, { 
        size: 'lg',
        backdrop: 'static',
        keyboard: false });

      this.toastr.info(
        'Ingrese los pagos',
        'Atención',
        {
          timeOut: 3000,
          closeButton: true,
          progressBar: true,
        }
      );
      return;
  }

  this.dineroRecibido = this.total;
  this.dineroEntregar = "0.00";

    this.modalService.open(basicModal,{
      backdrop: 'static'
    });
  }


  dineroRecibirCliente(event){

 
    var final = Number(event.target.value) - Number(this.total);

    this.dineroEntregar = parseFloat(final.toString()).toFixed(2)
    this.dineroEnt = final;

  }

  removeLaboratorioDuplicates(): void {
    const codesSeen = new Set<string>();
    this.detalleOrden = this.detalleOrden.filter(item => {
      if (!item) {
        return false;
      }

      if (item.tipo === 'LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)') {
        if (!codesSeen.has(item.codigo)) {
          codesSeen.add(item.codigo);
          return true; // Agregar al array resultante
        } else {
          return false; // Eliminar duplicado
        }
      } else {
        return true; // Mantener elementos que no son de tipo LABORATORIO
      }
    });
  }
  /* -------------------------------------------------------------------------- */
  /*                                GUARDAR ORDEN                               */
  /* -------------------------------------------------------------------------- */

  
  async guardarTransaccion(){

    if(this.nombreUsuario == "" || this.nombreUsuario == null){
      this.toastr.error("No se pudo obtener informacion del responsable, contacte con soporte!", 'Atención', {
        timeOut: 7000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if(this.esTarjeta){
      if(this.companiaBancaria == "" || this.companiaBancaria  == null){
        this.toastr.error("Seleccion el tipo de tarjeta", 'Atención', {
          timeOut: 7000,
          closeButton: true,
          progressBar: true
        });
        return;
      }
    }


    if (this.metodoPagoV == 'PAGO MULTIPLE') {

      if((this.arrayPagos.length == 0) ){
        
        this.toastr.info(
          'Ingrese los pagos!',
          'Atención',
          {
            timeOut: 3000,
            closeButton: true,
            progressBar: true,
          }
        );

        return;
      }

      if (this.totalPagosRealizados() > this.total) {

        this.toastr.info(
          'El total de los pagos es mayor a la transaccion!',
          'Atención',
          {
            timeOut: 3000,
            closeButton: true,
            progressBar: true,
          }
        );
        return;
      }
    }
       const tipos = this.detalleOrden.map(s => s.tipo);

      const hayBazar = tipos.includes("BAZAR");
      const hayOtroTipo = tipos.some(t => t !== "BAZAR");

      if (hayBazar && hayOtroTipo) {
         this.toastr.info(
          '¡No se puede mezclar productos de BAZAR con servicios en la misma orden, verificar!',
          'Atención',
          {
            timeOut: 3000,
            closeButton: true,
            progressBar: true,
          }
        );
        return;
      }
    this.esAnalisiCefa = "No";
    this.detalleOrden.forEach(servicio => {
      if(servicio.codigo == "ANALISIS CEFA"){
        this.esAnalisiCefa = "Si";
      }
    })


  if (this.detalleOrden.length<=0) {

        this.toastr.info(
          'Ingrese al menos un servicio!',
          'Atención',
          {
            timeOut: 3000,
            closeButton: true,
            progressBar: true,
          }
        );
        return;
    }
  

    const tarjeta = this.companiaBancaria.split(',');
    let codigoTarjeta = tarjeta[0] || "";
    let nombreTarjeta = tarjeta[1] || "";

    this.disabledGuardarMP = true;
    this.spinnerGuardarMP = true;
    this.spinnerBoolean = true;
    this.cargando = "Generando Orden un momento...";
    this.guardarOrden = true;

    await this.anularOrdenesPacienteDoctor(this.idPaciente,this.codigoDoctor,localStorage.getItem('token'));

    this.ordenesService.guardarOrden(
      this.idPaciente,
      this.nuevoTelefonoEnCardP,
      this.nuevoTelefonoEnCardD,
      this.cedulaDoctor,
      this.codigoDoctor,
      this.nombreDoctor,
      this.telefonoDoctor,
      JSON.stringify(this.detalleOrden),
      this.idSucursal,
      this.secuencial,
      this.metodoPagoV,
      codigoTarjeta,
      nombreTarjeta,
      this.esAnalisiCefa,
      "normal",
      "",
      localStorage.getItem('token'),
      this.reserved,
    ).subscribe((resp) => {

      if(resp.toString().split(",")[0].length == 20){

        this.cargando = "Registrando descuento un momento...";
        this.ordenesService.generarDescuento(
          resp.toString().split(",")[1],
          this.idUsuario,
          this.nombreUsuario,
          this.metodoPagoV,
          this.subtotalImpuesto,
          this.subtotalSinImpuesto,
          this.subtotal,
          this.iva,
          this.total,
          this.secuencial,
          this.dineroRecibido,
          this.dineroEntregar,
          this.idSucursal,
          this.nombreSucursal,
          codigoTarjeta,
          nombreTarjeta,
          JSON.stringify(this.arrayPagos),
          localStorage.getItem('token'),
          "",
          this.emergency,
          this.observacionesPaciente
        ).subscribe({
          next: (descuento) => {
            this.spinnerGuardarMP = false;
            this.disabledGuardarMP = false;
            this.spinnerBoolean = false;
            this.guardarOrden = false;
            this.cargando = "Finalizando...";
            this.modalService.dismissAll();
            this.toastr.success(
              `Descuento ${descuento.secuencial} registrado correctamente`,
              'Atención',
              {
                timeOut: 7000,
                closeButton: true,
                progressBar: true
              }
            );
            this.router.navigateByUrl('/sistema/descuentos');
          },
          error: (error) => {
            this.spinnerGuardarMP = false;
            this.disabledGuardarMP = false;
            this.spinnerBoolean = false;
            this.guardarOrden = false;
            this.errorTransaccion = true;
            this.errorCapturado =
              error?.error?.message || error?.message || 'No se pudo registrar el descuento';
            this.toastr.error(this.errorCapturado, 'Atención', {
              timeOut: 9000,
              closeButton: true,
              progressBar: true
            });
          }
        });
        
   

      }else{
        this.spinnerGuardarMP = false;
        this.disabledGuardarMP = false;

        this.errorTransaccion = true;
        this.errorCapturado = resp;
      
        this.toastr.error(resp, 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
          
      }

    });
    
   

  }

  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJ12345679KLMNOPQRST08765454UVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /* --------------------- VALIDAR ORDEN PENDIENTE CLIENTE -------------------- */
  validarOrdenPendienteCliente(idPaciente,token){

    return new Promise((resolve)=>{
      this.ordenesService.validarExistenciaOrdenPendiente(idPaciente,token).subscribe(resp=>{
        resolve(JSON.parse(resp));
      })
    })

  }

    /* --------------------- VALIDAR ORDEN PENDIENTE CLIENTE -------------------- */
    anularOrdenesPacienteDoctor(idPaciente,codigoDoctor,token){

      return new Promise((resolve) => {
        this.ordenesService.anularOrdenesPacienteDoctor(idPaciente,codigoDoctor,token).subscribe(resp=>{
          resolve(JSON.parse(resp));
        })
      })
  
    }


  imgBase(){

    this.detalleOrden.map((item) => {
     
      item.imagenes.map((item1) => {
        const file = item1;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {


         
         
         await item.imagenesBase.push({
  
              "imagenes" : reader.result
            })
               
        };
  
      });
    });
   
    
  }

  mostrarModalInformacion(basicModal:any,idInformacion){

    this.modalService.open(basicModal,{
      backdrop: 'static'
    });

    this.spinnerBoolean = true;
    this.ordenesService.informacionPruebas(
      idInformacion
    ).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp));

       this.txtPruebaInformacion = content.NOMINF_LAB;
       this.txtMuestrarInformacion = content.MUEINF_LAB;
       this.txtContenedor = content.CONINF_LAB;
       this.txtCondicion = content.CONDINF_LAB;
       this.txtEntregaResultados = content.RESINF_LAB;
       this.spinnerBoolean = false;
    });
  }

  solicitudDescuentoMasivo(event,basicModal:any){
    this.tipoMensaje = "masivo";
    this.cbxPrecioSugerido = true;
    this.txtPrecioSugerido = "";
    this.contenedorValidarPrecio = false;
    this.codigoFacturadorValidacion= "";
        this.solicitudPrecioActualId = "";
        this.solicitudPrecioResultado = null;
        this.codigosAprobadosHoy = [];

    this.modalService.open(basicModal,{
      backdrop: 'static'
    });
  }


  validarCodigoMasivo(){
    const codigoSolicitudPrecio = this.obtenerCodigoSolicitudPrecio();
    if (!codigoSolicitudPrecio) {
      this.mostrarCodigoSolicitudNoDisponible();
      return;
    }

    this.ordenesService.encriptarCodigo(localStorage.getItem('token'), codigoSolicitudPrecio).subscribe((resp) => {
      var content = JSON.parse(JSON.stringify(resp));
      this.codigoFacturadorValidacion  = content[0].BASE;
      if(this.codigoFacturadorValidacion == this.codigoValidacion){

        this.toastr.success("Código validado correctamente", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });

        this.detalleOrden.forEach((currentServicio,index)=>{
            let precioFinal = 0;
            let precioNormal = Number(currentServicio.precio1);
            let precioSugerido = Number(this.txtPrecioSugerido) ?? 0;

            precioFinal = Number(precioNormal) - (Number(precioNormal) * Number(precioSugerido)/100);
            this.detalleOrden[index].preciosSelect.push({
              "precio" : precioFinal,
              "porcentaje" : precioSugerido+"%: "
            })
            this.detalleOrden[index].precioSeleccionado  = parseFloat(precioFinal.toString()).toFixed(2);
        })
        this.modalService.dismissAll();
        this.sumarTotalPrecios();
      }else{

        this.toastr.error("Código invalido", 'Atención', {
          timeOut: 9000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }


  changeReserva(event, reserved: any, index: number) {
    if (!this.detalleOrden[index]) {
      return;
    }

    if (event.target.checked) {
      this.detalleOrden[index].reserved = true;
      this.reserved = 0;
    } else {
      this.detalleOrden[index].reserved = false;
      this.reserved = 1;
    }

  }

  toggleAllReservations(event: any) {
    this.allSelected = event.target.checked;
    if(this.allSelected){

      this.reserved = 0;
      
    }else{

      this.reserved = 1;
    }

    this.detalleOrden.forEach(item => {
      if (item) {
        item.reserved = this.allSelected;
      }
    });
  }


  toggleEmergency(event: any) {
    this.emergency = event.target.checked;
  }

  changeObservacion(event, index){

 
   this.detalleOrden[index].pieza  = event.target.value



  }

  limpiarTitulo(texto: string): string {
    return texto.replace(/\s*\(.*?\)\s*/g, ''); // elimina todo lo que esté entre paréntesis
  }


  buarRadiografiaCorporal(codigo, modalSubserviciosCorporal, subservicios){
    this.servicioEscodigo = codigo;
    this.subservaciosSeleccionadosCorporal = [String(codigo)];
    this.listaSubServiciosCorporal = JSON.parse(subservicios);
    this.modalService.open(modalSubserviciosCorporal, {
      backdrop: 'static'
    });
  }

  seleccionaSubserviciosCorporal(event,index,id){
    const idNormalizado = String(id);
    if(event.checked){
      if (!this.subservaciosSeleccionadosCorporal.includes(idNormalizado)) {
        this.subservaciosSeleccionadosCorporal.push(idNormalizado);
      }
    }else{
      this.subservaciosSeleccionadosCorporal = this.subservaciosSeleccionadosCorporal.filter(
        a => String(a) !== idNormalizado
      );
    }
  }

  private hasApiError(resp: any): boolean {
    if (resp == null) return true;
    if (typeof resp === 'string') return resp.toLowerCase().includes('permiso denegado');
    const detalle = String(resp?.rows?.[0]?.detalle || resp?.message || '').toLowerCase();
    return detalle.includes('permiso denegado') || detalle.includes('unauthorized') || detalle.includes('forbidden');
  }

  private extractApiError(resp: any, fallback: string): string {
    if (typeof resp === 'string' && resp.trim()) return resp;
    const detalle = String(resp?.rows?.[0]?.detalle || resp?.message || '').trim();
    return detalle || fallback;
  }

  private showApiError(resp: any, fallback: string): void {
    this.toastr.error(this.extractApiError(resp, fallback), 'Atención', {
      timeOut: 4000,
      closeButton: true,
      progressBar: true
    });
  }


  agregarDetalleCorporal(){
    
  
  this.serviciosService
  .mostrarSubServiciosById(localStorage.getItem('token'), this.servicioEscodigo)
  .subscribe((resp) => {

    const seleccionados = new Set(
      this.subservaciosSeleccionadosCorporal.map(id => String(id))
    ); // Los IDs del modal son strings y COD_PRO puede llegar como number.
    resp
      .filter(x => seleccionados.has(String(x.COD_PRO))) // Comparación estable entre API y modal.
      .forEach((currentValue, index) => {

        const itemP = this.precioItem(
          currentValue.CODN_PRO,
          currentValue.VAL_PRO,
          currentValue.VAL2_PRO,
          currentValue.VAL3_PRO,
          currentValue.VAL4_PRO,
          currentValue.DER_PRO,
          currentValue.TIP_PRO,
          currentValue.preciosLab,
          currentValue.VALEMP_PRO
        );

        const precioSeleccion = itemP.split(",")[0];
        const preciosSelect: any[] = [
          { precio: precioSeleccion, porcentaje: "" },
          { precio: itemP.split(",")[1], porcentaje: "PRECIO B: " },
          { precio: itemP.split(",")[2], porcentaje: "PRECIO C: " },
          { precio: itemP.split(",")[3], porcentaje: "PRECIO EST: " },
        ];

        this.detalleOrden.push({
          id: currentValue.COD_PRO,
          producto: currentValue.NOM_PRO,
          codigo: currentValue.CODN_PRO,
          valor: currentValue.VAL_PRO,
          pieza: "Ninguna",
          agregado: " ",
          precio1: precioSeleccion,
          precio2: itemP.split(",")[1],
          precio3: itemP.split(",")[2],
          precio4: itemP.split(",")[3],
          impuesto: currentValue.IMP_PRO,
          incluidoIva: currentValue.INCLIVA_PRO,
          precioSeleccionado: precioSeleccion,
          tipo: currentValue.TIP_PRO,
          preciosSelect,
          reserved: true
        });

      });

    // resto igual...
    this.toastr.success("Servicios agregado correctamente a la orden", 'Atención', { timeOut: 4000, closeButton: true, progressBar: true });
    this.modalService.dismissAll();
    this.servicioEscodigo = "";
    this.subservaciosSeleccionadosCorporal=[];
    this.cadenaAB = "";
    this.cadenaConduct = "";
    this.cadenaIZ = "";
    this.cadenaPiezas = "";
    this.cadenaSI = "";
    this.sumarTotalPrecios();
  });

  }

}


export class LanguageApp {
  public static spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ registros",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Ant",
      next: "Sig",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }
}
